import React, { Component, useEffect, useState ,useRef} from 'react';

import { Helper } from '../src/ToolKit/toolkit.js';
import { DataClass, enums } from '../src/ToolKit/DataClass.js'
import { Chart } from "chart.js/auto";
import $ from 'jquery/dist/jquery';
import { Menu, ColumnType, Action , AlertD, YesNo, DropDownBox, SelectBasic, DayTimeSelector, FormDiv, InputBox, Icon, SideView, SideItem, FilterView, SpecValues, ProTable, SimpleButton, CustomHelper, FixedMessage, Captia, Column, NewRecordValue, FromBasic, AddButton, FileProgess, LoadingBar, FromSubmit, InputTextBox, InputPasswordBox, Model, Confirm, RowState, ShowFixedPage, BackButton } from './Componet';
import { BrowserRouter, Routes, Route, Outlet, Link, useParams } from "react-router-dom";
import { ajax, data, extend } from 'jquery';
import * as jquery from '../node_modules/jquery/dist/jquery.js';
import ProductList, {  ShowProduct } from './SubSystem/ClientHub/Pages';
import {
    Pie, Cell,
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
    ResponsiveContainer
} from "recharts";

import { Sidebar, Menu as PMenu   , MenuItem, SubMenu } from 'react-pro-sidebar';
import { AddFTTHRequest } from './SubSystem/ModemInstallAndService/pages.jsx';
let masterPage = null;

const currentState = { GetLoginInfo: 0, LoginNeed: 1, Logined: 2 }
const loginMode = { None:0,SimpleMode:1, ByPhone :2 ,SelectDoctor:3,InputMode:4,SelectLabTime:5}
 

const DynChart = ({ title, chartType, values }) => {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (chartInstance.current) chartInstance.current.destroy();

        const ctx = chartRef.current.getContext("2d");

        // گرادیان برای هر رنگ
        const gradients = values.map(v => {
            const g = ctx.createLinearGradient(0, 0, 0, 300);
            g.addColorStop(0, v.color);
            g.addColorStop(0.1, "#333333");
            g.addColorStop(1, v.color);
            return g;
        });

        chartInstance.current = new Chart(ctx, {
            type: chartType === 0 ? "pie" : "line",
            data: {
                labels: values.map(v => v.label),
                datasets: [
                    {
                        label: title,
                        data: values.map(v => v.value),
                        backgroundColor: gradients,
                        borderColor: "#333",
                        borderWidth: 0.5,
                        hoverOffset: 15,
                        tension: 0.4,
                        pointBackgroundColor: "#fff",
                        pointBorderColor: "#000",
                        pointRadius: 6,
                        pointHoverRadius: 10,
                        shadowColor: "rgba(0,0,0,0.3)",
                        shadowBlur: 10
                    }
                ]
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        position: "bottom",
                        labels: {
                            color: "#444",
                            font: {
                                family: "IranSan",
                                size: 14,
                                weight: "bold"
                            }
                        }
                    },
                    title: {
                        display: true,
                        text: title,
                        color: "#222",
                        font: {
                            family: "IranSan",
                            size: 22,
                            weight: "bold"
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: ctx =>
                                `${ctx.label} => ${ctx.formattedValue} `
                        }
                    }
                },
                animation: {
                    duration: 1500,
                    easing: "easeOutElastic"
                }
            }
        });
    }, [chartType, values, title]);

    return <canvas   height="300px" ref={chartRef} />;
};

export default DynChart;

window.goToLink=function(id)
{
    var c = $('#' + id);
    if (c.length == 0) {
        console.log(id + " not found");
    }
    c[0].click();
}

export class GameDetailMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('GameDetail', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('GameDetail', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='GameDetail' /> <ProTable Records={this.state.Records} datasourcename='GameDetails'>
                    <Column metaForDisplay={DataClass.GameDetail.id} />

                    <Column caption="عنوان بازی" columnName="gameTitle" type={ColumnType.DisplayValue} />
                    <Column metaForDisplay={DataClass.GameDetail.detailType} />
      
                    <Action caption="ویرایش" type="Link" pageName="/GameDetail/Edit" columnName="id" />


                    <Action caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}

export class AddGameDetail extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('GameDetail', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('GameDetail', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
           
            <InputBox meta={DataClass.GameDetail.GameId} size='50%' />
        
            <InputBox meta={DataClass.GameDetail.detailType} size='50%' />
            <InputTextBox initValue="context"   caption="محتوا" size="100%" columnName="context" model="context" customHelper={CustomHelper.Html} ></InputTextBox>

        </FromSubmit>

    }

}


export class CategoryMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("PostSys", "CategoryList", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.Categorys);
        h.Ajax('PostSys', 'SaveCatBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='Categorys' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.Category.id} />
                    <Column metaForInput={DataClass.Category.title} />

                </ProTable>

            </FromSubmit>

        }

    }


}




export class PostMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('PostSys', 'PostDelete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('PostSys', 'PostList', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle='مدیریت مطالب'>
                <AddButton title='پست' entity='Posts' /> <ProTable Records={this.state.Records} datasourcename='Posts'>
                    <Column metaForDisplay={DataClass.Post.id} />
                    <Column metaForDisplay={DataClass.Post.title} />
                    <Column metaForDisplay={DataClass.Post.user_id} />
                    <Column metaForDisplay={DataClass.Post.PostType} />

                    <Column metaForDisplay={DataClass.Post.createTime} />
                    <Column columnName="catName" caption="دسته" type={ColumnType.DisplayValue} />

                    <Column metaForDisplay={DataClass.Post.subTitle} />


                    <Action caption="ویرایش" type="Link" pageName="/Posts/Edit" Icon="Edit" columnName="id" />


                    <Action caption="حذف" type="function" Icon="Delete" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }

}
export class AddPost extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('PostSys', (cmd.id == '-1' ? 'PostInsert' : 'PostUpdate'), { Model: o, id: id }, function (data) {
            h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
            h.GoBack();
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('PostSys', 'PostGet', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>

            <InputBox meta={DataClass.Post.title} size='50%' />
            <InputBox meta={DataClass.Post.PostType} size='50%' />


            <InputBox meta={DataClass.Post.CatId} size='50%' />

            <InputBox meta={DataClass.Post.subTitle} size='50%' />
            <InputBox meta={DataClass.Post.picture} size='50%' customHelper={CustomHelper.Image} />
            <InputBox meta={DataClass.Post.context} size='100%' customHelper={CustomHelper.Html} />

            <InputBox meta={DataClass.Post.keywords} size='100%' />


        </FromSubmit>

    }

}


class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { checkForLogin: false  }

    }
    componentDidMount() {

        let hlp = new Helper();
        let cmd = this;
        if (localStorage.getItem('token') != null) {
            cmd.setState({ checkForLogin: true });
            hlp.Ajax('Home', 'GetLoginInfo', {},
                function (data) {
                    cmd.setState({ checkForLogin: false });
                    if (data.logined == true) {
                        window.goToLink('AdminPage');
                    }
                    else {
                        cmd.setState({ checkForLogin: false });
                        localStorage.clear();
                    }
                }, function (err) {
                    cmd.setState({ checkForLogin: false });
                    localStorage.clear();

                });
        }
    }
    login() {
        let helpCls = new Helper();
        let cmd = this;
        let o = helpCls.GetPostData();
        let data = { o };
        helpCls.Validate();

        if (helpCls.isValidate() == false) {

            return false;
        }
        helpCls.Ajax("Home", "Login", o, function (result) {
            if (result.message != '') {
                helpCls.MessageBox(result.message, '');

                window.CaptiaBase.setState({ isLoaded: false, url: '' });
                window.CaptiaBase.reload();
            }
            else {
                localStorage.setItem('token', result.token);
                document.cookie = 'jwt=' + result.token;
                window.goToLink('AdminPage');
            }
        }

        )
    }
    containr(props = {title:''}) {
        return <div style={{ color: 'black' }}>

            <div style={{ position: 'fixed', color: 'black', background: 'url(/backgrounds/Bk.jpg)', backgroundSize: 'cover', left: '0px', top: '0px', zIndex: '-10', bottom: '0px', right: '0px' }} />
            <center>
                <div className="container">
                    <div className="row" style={{ padding: '25px' }}>
                        <center>
                            <div className="col-sm-3" style={{ backdropFilter: 'blur(5px)', fontSize: 'small', minWidth: '300px', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', background: '#ffffff57', borderRadius: '5px', boxShadow: '1px 1px 3px black' }} role="alert">

                                <FromBasic staticTitle={props.title} >
                                    {props.children}
                                </FromBasic>                   <Link to="/" id="Startup" ></Link>
                                <Link to="/Admin/Index.html" id="AdminPage" ></Link>
                                طراحی و اجرا :پرویز بازگشا
                            </div>
                        </center>
                    </div>
                </div>




            </center>
            <Model />
            <Confirm />
            <AjaxStatus />
        </div>;

    }

    render() {
        if (this.state.checkForLogin == true) {
            return <div><LoadingBar></LoadingBar> در حال بارگذاری  <Link to="/Admin/Index.html" id="AdminPage" ></Link></div>;

        }


        return  <this.containr title="ورود به سامانه" >
                                <div style={{ textAlign: 'right' }} >

                                    
                                    <InputTextBox caption='شناسه کاربری' size='100%' columnName='userName' mustFill='yes' />
                                    <InputPasswordBox caption='گذرواژه' size='100%' columnName='password' mustFill='yes' />
                                    <br />

                                    <Captia />
                                </div>
                                <center>

                                    <Link to="/ForgetPassword" style={{ color: 'black' }} >رمز عبور خود را فراموش کردم</Link>
                <br />
                <Link to="/RegUser" style={{ color: 'black' }} >
                    <SimpleButton title="ثبت نام"></SimpleButton>

                </Link>
                <br />
                                    <button type="button" className="btn btn-primary" onClick={this.login}   ><Icon Icon="Sec" />  {FixedMessage.Login}</button>
                                    <SimpleButton Icon="Cancel" title="بازگشت" onClick={() => {
                                        window.location = "/";
                                    }} ></SimpleButton>


                                </center>



           </this.containr>
         
    }

}

export class GamesList extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            level: 1, planId: 0, conso: 0, plans: [], game: [], prices: [], selectedPrice: {}, priceIndex: -1
        };

    }
    componentDidMount() {
        this.loadData();
    }
    loadData() {
        let s = this.state;
        let h = new Helper();
        let cmd = this;
        h = h.Ajax('Home', 'AllPlan', {}, (data) => {
            s.plans = data;
            cmd.setState(s);
            this.loadGames();

        });
    }
    loadGames() {
        let s = this.state;
        let h = new Helper();
        let cmd = this;
        h = h.Ajax('Home', 'AllGames', { id: this.state.planId }, (data) => {
            s.game = data;
            cmd.setState(s);

        });
    }
    loadPrice() {
        let s = this.state;
        let h = new Helper();
        let cmd = this;
        h = h.Ajax('Home', 'AllPriceOfPlan', { planTitle: '', planId: this.state.planId, console: this.state.conso }, (data) => {
            s.prices = data;
            cmd.setState(s);

        });
    }
    selectConsole(conType) {
        let s = this.state;
        s.level += 1;
        s.conso = conType;
        this.setState(s);
    }
    reg() {
        let h = new Helper();
        h.Validate();
        if (this.state.selectedPrice == null) {
            h.errors.push("لطفا یک گزینه برای طرح انتخاب کنید");
        }
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetPostData();
        var keys = Object.keys(this.state.selectedPrice);
        for (var l = 0; l < keys.length; l++) {
            data[keys[l]] = this.state.selectedPrice[keys[l]];
        }
        let cmd = this;
        h.Ajax('Home', 'Reg', data, (data) => {
            if (data.status == '200') {
                h.Alert(data.message);
                let s = cmd.state;
                s.level = 3;
                cmd.setState(s);
            }
            else {
                h.Error(data.message);
            }
        });
    }
    render() {
        let h = new Helper();
        return <div>
            <div style={{ position: 'fixed', color: 'black', background: 'url(/backgrounds/Bk.jpg)', backgroundSize: 'cover', left: '0px', top: '0px', zIndex: '-10', bottom: '0px', right: '0px' }} />
            <center>
            
                <div className="col-sm-12" style={{ background: 'white', borderRadius: '5px', boxShadow: '1px 1px 3px black' }} role="alert">

                    <FromBasic staticTitle='لیست بازی ها' >



                        
                        {this.state.level == 1 &&
                            <span>
 
                                <FromBasic>
                                {this.state.game.map((v) => {
                                    return <div className="col-sm-3">
                                        {v.title} <br />
                                        <img width="80px" src={"/images/cover/" + v.id + ".jpg"} ></img>

                                    </div>
                                })}
                                </FromBasic>
                                
                            </span>
                        }
                       
                    </FromBasic>
                    <Link to="/" id="Startup" ></Link>
                    <Link to="/Admin/Index.html" id="AdminPage" ></Link>
                    طراحی و اجرا :پرویز بازگشا
                </div>
            </center>
            <Model />
            <Confirm />
            <AjaxStatus />
        </div>;
    }
}



export class AddGame extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('Games', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        $('#txtDisplayProt').val('0');
        if (this.id != -1) {
            h.Ajax('Games', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
        
            <InputBox meta={DataClass.Game.title} size='50%' />
            <InputBox meta={DataClass.Game.gameType} size='50%' />
            <InputBox meta={DataClass.Game.Link} size='50%' />
            <InputBox meta={DataClass.Game.useMode} size='50%' />
            <InputBox meta={DataClass.Game.DisplayProt} size='50%' />
            <InputBox meta={DataClass.Game.DatePublish} size='50%' />
            <InputBox meta={DataClass.Game.rating} size='50%' />
            <span>اگر نوع بازی پلی استیشن 4 انتخاب گردد برای کاربر دارای پلی استیشن 4 یا 5 قابل انتخاب است و اگر پلی استیشن 5 باشد فقط برای کاربر پلی استیشن  5</span>
            <br/>
            <span>در حالت اولویت صفر قرار داده برای نمایش به صورت بالاتر 1 یا بیشتر قرار دهید</span>
        </FromSubmit>

    }

}

export class PlanMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Plan', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Plan', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='Plan' /> <ProTable Records={this.state.Records} datasourcename='Plans'>
                    <Column metaForDisplay={DataClass.Plan.id} />
                    <Column metaForDisplay={DataClass.Plan.title} />
                    <Column metaForDisplay={DataClass.Plan.planZType} />

                    <Action caption="ویرایش" type="Link" pageName="/Plan/Edit" Icon="Edit" columnName="id" />


                    <Action caption="حذف" type="function" Icon="Delete" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}


export class AddPlan extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
        this.state = { Records :[]};
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        let gameID = [];
        let ar = h.GetRecordWithCircita(window.games, 'selected', true);
        for (let i = 0; i < ar.length; i++) {
            gameID.push(ar[i].id);
        }

        h.Ajax('Plan', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id, gameIds: gameID }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
       
       
    }
    componentDidMount() {
        let h = new Helper();
        let cmd = this;
        if (this.id != -1) {
            h.Ajax('Plan', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
              
            });


        }
        h.Ajax('Plan', 'ShowGameForPlan', { planId: cmd.id }, (data) => {
            cmd.setState({ Records: data });
            window.games =data;
        });
    }




    render() {
        return <FromSubmit SubmitButtonOnTop={true } submitBev={this.submit}>
          
            <InputBox meta={DataClass.Plan.title} size='50%' />
            <InputBox meta={DataClass.Plan.planZType} size='50%' />
            <InputBox meta={DataClass.Plan.Descr} size='100%' />
            <div class="col-sm-6">
                <InputBox meta={DataClass.Game.rating} size='100%'></InputBox>
                <center>
                    <SimpleButton title="انتخاب بر رده سنی" onClick={() => {
                        data = window.games;
                        let v = $('#txtrating').val();
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].rating == v) {
                                data[i].selected = true;
                            }
                        }
                        window.games = data;
                        this.setState({ Records: data });
                    }}></SimpleButton>
                </center>


            </div>
            <div class="col-sm-6">
                <InputTextBox caption="تعداد روز گذشته" columnName="date" model="datepass" size='100%' />
                <center>
                    <SimpleButton title="انتخاب بر تاریخ عرضه" onClick={() => {
                        data = window.games;
                        let v = parseInt($('#txtdate').val());

                        for (let i = 0; i < data.length; i++) {
                            if (data[i].dayPub >= v) {
                                data[i].selected = true;
                            }
                        }
                        window.games = data;
                        this.setState({ Records: data });
                    }}></SimpleButton>
                </center>




            </div>
            <hr/>
            
         


            <ProTable Records={this.state.Records} datasourcename='Games'>
               
                <Column type={ColumnType.DisplayValue} columnName='title' caption='عنوان بازی' />
                <Column type={ColumnType.Image} caption="تصویر" columnName="id" url="/images/cover/" ext=".jpg" />
                <Column type={ColumnType.DisplayValue} columnName='dayPub' caption='زمان گذشته از عرضه' />
                <Column metaForDisplay={DataClass.Game.rating} />
                <Column type={ColumnType.InputCheck} columnName='selected' />
            </ProTable>

        </FromSubmit>

    }

}

export class PriceMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
        this.x = 0;
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Plan", "PriceList", {}, function (datas) {
            cmd.x = 0;
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    allState() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Plan", "CrossPrice", {}, function (datas) {
            cmd.x = 1;
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });
    }

    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let rec = [];
        for (let i = 0; i < this.state.Records.length; i++) {
       
            if (this.state.Records.rowState === undefined) {
                rec.push(this.state.Records[i]);

            }
            else {
                if (this.state.Records.rowState != RowState.Deleted) {
                    rec.push(this.state.Records[i]);
                }
            }
        }
        h.Ajax('Plan', 'PriceSave', { Records: rec }
            , function (data) {

                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        );
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <SimpleButton title="تمامی حالت ها" Icon="Yes" onClick={() => { this.allState(); }}></SimpleButton>
                <ProTable datasourcename='Prices' key={this.x} Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForInput={DataClass.Price.planId} titleColumnName="priceName"   />
                    
                    <Column metaForInput={DataClass.Price.timeDurrion} />
                    <Column metaForInput={DataClass.Price.console} />
                    <Column metaForInput={DataClass.Price.gameCount} />
                    <Column metaForInput={DataClass.Price.price} />

                </ProTable>

            </FromSubmit>

        }

    }


}
 



export class GameMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Games', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }
    CreateProduct(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Games', 'CreateProduct', { Model: record }, function (data) {
                cmd.componentDidMount();
                // hlp.MessageBox(data.message, FixedMessage.Result);
                hlp.Alert(data.message);
            });
        });

    }


    PriceShow(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.MessageBox(record.priceDescr, 'نرخ');
    }
    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Games', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
            window.Games = data;
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
               
                <center>
                    <AddButton title='' entity='Game' />
                    <span style={{ width: '150px', display: 'inline-block' }}> </span>
                    <SimpleButton title="ذخیره اکانت ها به صورت فایل متنی" onClick={() => {
                        let h = new Helper();
                        h.viewFile('/Games/DownloadBackup', 'Games-Backup.zip');
                    }}></SimpleButton>
                    <SimpleButton Icon="Delete" title="حذف دسته ای" onClick={() => {
                        let cmd = this;
                        var hel = new Helper();
                        hel.ConfirmAction("آیا مطممن هستید؟", "پرسش", (dx) => {
                            let rec = hel.GetRecordWithCircita(window.Games, 'selected', true);
                            hel.Ajax('Games', 'DeleteBatch', { rec: rec }
                                , (okdata) => {
                                    hel.Alert(okdata.message);
                                    if (okdata.status == 200)
                                    {
                                        cmd.componentDidMount();
                                   }
                                  
                                }
                            );

                        });
                      


                    }}></SimpleButton>
                </center>
                

                <ProTable Records={this.state.Records} key={Date().toString()} datasourcename='Games'>
                    <Column metaForDisplay={DataClass.Game.id} />
                    <Column type={ColumnType.Image} caption="تصویر" columnName="id" url="/images/cover/" ext=".jpg" />
                    <Column metaForDisplay={DataClass.Game.title} />
                    <Column metaForDisplay={DataClass.Game.gameType} />
                   
                    <Column type={ColumnType.InputCheck} columnName='selected' />
                    <Action caption="ایجاد محصولات" type="function" Icon="Delete" targetFun={this.CreateProduct} />
                    <Action caption="ویرایش ارتباط و تعرفه ظرفیت ها" type="Link" Icon="Edit" pageName="/GamePrices" columnName="id" />


                    <Action caption="تعیین عکس" type="Link" Icon="Yes" pageName="/UploadImageObj/cover" columnName="id" />

                    <Action caption="ویرایش" type="Link" Icon="Edit" pageName="/Game/Edit" columnName="id" />
                    <Action caption="اکانت ها" type="Link" Icon="Basic" pageName="/Game/Accounts" columnName="id" />
                    <Action caption="تخصیص اکانت ها" type="Link" Icon="Basic" pageName="/GameList/AccMgt" columnName="id" />

                    <Action caption="نمایش قیمت" type="function" Icon="Cat" targetFun={this.PriceShow} />

                    <Action caption="حذف" type="function" Icon="Delete" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}

export class PriceGameMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = this.props.id;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Games", "PriceGameList", {id:this.id}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.PriceGames);
        h.Ajax('Games', 'PriceGameSaveBatch', { id:this.id ,Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='PriceGames' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.PriceGame.id} />
                
                    <Column metaForInput={DataClass.PriceGame.type} />
                    <Column metaForInput={DataClass.PriceGame.Price} />
                    <Column metaForInput={DataClass.PriceGame.PriceType} />

                </ProTable>

            </FromSubmit>

        }

    }


}


export class AccountMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Games", "AccList", { GameId: this.id }, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.Accounts);
        h.Ajax('Games', 'SaveAccList', { GameId: this.id, Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='Accounts' Records={this.state.Records} Insertable={true} Deleteable={true}>
                 
                
                    <Column metaForInput={DataClass.Account.UserName} />
                    <Column metaForInput={DataClass.Account.Password} />
                    <Column metaForInput={DataClass.Account.backupCodes} />
                    <Column metaForInput={DataClass.Account.usemode} />
                    <Column metaForInput={DataClass.Account.BirthDate} />
                    <Column metaForInput={DataClass.Account.PsnId} />
                    <Column metaForInput={DataClass.Account.DeactiveDate} />
                    <Column metaForDisplay={DataClass.Account.UpdateTime} />
                </ProTable>

            </FromSubmit>

        }

    }


}


export function GameSelector(props) {

    const [pageState, loadGames] = useState({ games: [], isLoaded: false, filter: '' });

    const loadData = function () {
        let h = new Helper();
        h.Ajax('Games', 'List', {}, (data) => {
            loadGames({ games: data, isLoaded: true, filter: pageState.filter })
        });
    }

   
    if (!pageState.isLoaded) {
        loadData();
    }
    let gametarget = [];
    if (pageState.filter != '') {

        for (let i = 0; i < pageState.games.length; i++) {
            if (pageState.games[i].title.toLowerCase().indexOf(pageState.filter.toLowerCase()) != -1) {
                gametarget.push(pageState.games[i]);
            }
        }
    }
    else {
        gametarget = pageState.games;
    }
    return <FromBasic static="انتخاب بازی">
        <div className="col-12">
            <input className="form-control" id="txtFilter" placeholder="برای جست و جو اینجا کلیک کنید" onKeyUp={() => {
                let v = $('#txtFilter').val();
          
                let st = pageState;
                st.filter = v;
                loadGames({ filter: v, games: pageState.games, isLoaded: pageState.isLoaded });
            }}></input>
        </div>

        

        {gametarget.map(v => {
            return <div className="col-3">
                <center>
                    {v.title} <br />
                    <img width="80px" src={"/images/cover/" + v.id + ".jpg"} ></img>
                    <br />
                    <Link to={"AccMgt/" + v.id } >  <button type="button" class="btn btn-success">انتخاب بازی</button>
                    </Link>
                </center>
            </div>

        })}
         

    </FromBasic>;
}


export function ReturnGame(props) {

    const [pageState, loadGames] = useState({ games: [], isLoaded: false, filter: '' });

    const loadData = function () {
        let h = new Helper();
        h.Ajax('Gamer', 'ShowCurrentGames', {}, (data) => {
            if (data.status == 500) {
                h.Error(data.message);
                h.GoBack();
                return;
            }
            loadGames({ games: data, isLoaded: true, filter: pageState.filter });

        });
    }
    const submit = ( id) => {
        let h = new Helper();
        h.Ajax('Gamer', 'ReturnGame', { id: id }, (data) => {
            if (data.message != undefined) {
                h.Alert(data.message);

            }

        });
    };

    if (!pageState.isLoaded) {
        loadData();
    }
    let gametarget = [];
    if (pageState.filter != '') {

        for (let i = 0; i < pageState.games.length; i++) {
            if (pageState.games[i].title.toLowerCase().indexOf(pageState.filter.toLowerCase()) != -1) {
                gametarget.push(pageState.games[i]);
            }
        }
    }
    else {
        gametarget = pageState.games;
    }
    return <FromBasic static="انتخاب بازی">
        <div className="col-12">
            <input className="form-control" id="txtFilter" placeholder="برای جست و جو اینجا کلیک کنید" onKeyUp={() => {
                let v = $('#txtFilter').val();

                let st = pageState;
                st.filter = v;
                loadGames({ filter: v, games: pageState.games, isLoaded: pageState.isLoaded });
            }}></input>
        </div>

        <div class="games-grid">
        {gametarget.map((v) => {
            return <div class="game-card" >
                <img src={"/images/cover/" + v.gameId + ".jpg"}  class="game-image" />
              
                <div class="game-info">
                    <h3 class="game-title">{v.title}</h3>
                    <br /><span >

                   
                            <button type="button" class="btn btn-danger" onClick={() => {

                            submit(v.gameId);


                            }} >برگشت بازی </button>
                        
                    </span>
                </div>
            </div>



        })}

        </div>



    </FromBasic>;
}

export function NewGame(props) {

    const [pageState, loadGames] = useState({ games: [], isLoaded: false, filter: '' });

    const loadData = function () {
        let h = new Helper();
        h.Ajax('Gamer', 'ShowAvaGamesForUser', {}, (data) => {
            if (data.status == 500) {
                //h.Error(data.message);
                 
                return;
            }
            loadGames({ games: data, isLoaded: true, filter: pageState.filter });
        
        });
    }
    const submit = (type,gameId) => {
        let h = new Helper();
        h.Ajax('Gamer', type == 0 ? 'SaveGameForResver' : 'SaveGameForPlayer', { gameId: gameId }, (data) => {
            if (data.message != undefined) {
                h.Alert(data.message);
                if (data.status == 200) {
                    loadData();
                    window.reloadStatus();
                }
            }
          
        });
    };

    if (!pageState.isLoaded) {
        loadData();
    }

    const returnGame = (id) => {
        let h = new Helper();
        h.Ajax('Gamer', 'ReturnGame', { id: id }, (data) => {
            if (data.message != undefined) {
                h.Alert(data.message);
                if (data.status == 200) {
                    loadData();

                }
              
            }

        });
    };
    let gametarget = [];
    if (pageState.filter != '') {

        for (let i = 0; i < pageState.games.length; i++) {
            if (pageState.games[i].title.toLowerCase().indexOf(pageState.filter.toLowerCase()) != -1) {
                gametarget.push(pageState.games[i]);
            }
        }
    }
    else {
        gametarget = pageState.games;
    }
    return <FromBasic static="انتخاب بازی">
        <div className="col-12">
            <input className="form-control" id="txtFilter" placeholder="برای جست و جو اینجا کلیک کنید" onKeyUp={() => {
                let v = $('#txtFilter').val();

                let st = pageState;
                st.filter = v;
                loadGames({ filter: v, games: pageState.games, isLoaded: pageState.isLoaded });
            }}></input>
        </div>



        

        <div class="games-grid">
            {gametarget.map((v) => {
                return <div class="game-card" >
                    <img src={"/images/cover/" + v.gameId + ".jpg"}   class="game-image" />
                    
                  
                    <div class="game-info">
                        <h3 class="game-title">{v.title}</h3>
                        <br /><span >

                            <Link to={"/Admin/AboutGame/" + v.gameId } > <button type="button" class="btn btn-warning" onClick={() => {
                                let x = new Helper();
                              


                            }} >درباره بازی</button>

                            </Link>
                            {v.currentUsageId == null && <span>
                                {v.avable == true &&
                                    <button type="button" class="btn btn-primary" onClick={() => {

                                        submit(1, v.gameId);


                                    }} >درخواست بازی</button>
                                }
                                {v.avable == false &&
                                    <button type="button" class="btn btn-light" onClick={() => {

                                        submit(0, v.gameId);


                                    }} >روزو بازی</button>
                                }
                            </span>}
                            {v.currentUsageId != null && <span>

                                <button type="button" class="btn btn-primary" onClick={() => {

                                    returnGame( v.currentUsageId.id);


                                }} >برگشت بازی</button>
                            </span>}

                        </span>
                    </div>
                </div>



            })}



        </div>



    </FromBasic>;
}
export function ShowPost(props) {

    const [pageState, loadAccounts] = useState({ records: [], isLoaded: false, filter: '' });
    const params = useParams();
    const loadData = function () {
        let h = new Helper();
        h.Ajax('PostSys', 'GetPostContext', { id: params.id }, (data) => {
            loadAccounts({ records: data, isLoaded: true, filter: pageState.filter })
        });
    }


    if (!pageState.isLoaded) {
        loadData();
    }
    let h = new Helper();
    if (pageState.isLoaded == false) {
        return <span>لطفا صبر کنید</span>;
    }
    return <FromBasic>

        <h3>{pageState.records.n.title}</h3>   

        <span dangerouslySetInnerHTML={{ __html: pageState.records.n.context }}></span>

              
          
       
    </FromBasic>
}
export function AboutGame(props) {

    const [pageState, loadAccounts] = useState({ records: [], isLoaded: false, filter: '' });
    const params = useParams();
    const loadData = function () {
        let h = new Helper();
        h.Ajax('Gamer', 'AboutGame', { GameId: params.id }, (data) => {
            loadAccounts({ records: data, isLoaded: true, filter: pageState.filter })
        });
    }
    

    if (!pageState.isLoaded) {
        loadData();
    }
    let h = new Helper();
    if (pageState.isLoaded == false) {
        return <span>لطفا صبر کنید</span>;
    }
    return <FromBasic>
        <SideView>
            {pageState.records.map((v) => {
                return <SideItem id={v.id} title={h.GetCaptionFromEnum(enums.DetailType, v.detailType)}

                >
                    <span dangerouslySetInnerHTML={{ __html:v.context }}></span>

                </SideItem>
            })}
        </SideView>
    </FromBasic>
}
export function AccSelector(props) {

    const [pageState, loadAccounts] = useState({ accs: [], isLoaded: false, filter: '' });
    const params = useParams();
    const loadData = function () {
        let h = new Helper();
        h.Ajax('Games', 'AccUsage', { GameId: params.id }, (data) => {
            loadAccounts({ accs: data, isLoaded: true, filter: pageState.filter })
        });
    }


    if (!pageState.isLoaded) {
        loadData();
    }
    let lis = [];
    if (pageState.filter != '') {

        for (let i = 0; i < pageState.accs.list.length; i++) {
            if (pageState.accs[i].list.userName.toLowerCase().indexOf(pageState.filter.toLowerCase()) != -1) {
                lis.push(pageState.accs.list[i]);
            }
        }
    }
    else {
        lis = pageState.accs.list;
    }
    if (pageState.isLoaded == false) {
        return <span>لطفا صبر کنید</span>;
    }
    const showDetail = function (type, accID) {
        let h = new Helper();
        h.Ajax('Games', 'ShowDetail', { type: type, accId: accID }
            , (data) => {

                h.MessageBox(data.message,"اطلاعات تحویل");
            });
    }
    const showBack = function (type, accID) {
        let h = new Helper();
        h.Ajax('Games', 'ShowDetail', { type: type, accId: accID }
            , (data) => {

                h.ConfirmAction(data.message + "<br/> آیا برگشت داده شود به تاریخ امروز? ", "اطلاعات تحویل"

                    , (dx) => {
                        h.Ajax('Games', 'GetBack', { type: type, accId: accID }, (dx) => {
                            if (dx.status == "200") {
                                h.MessageBox(dx.message);
                                loadData();
                            }
                            else {
                                h.MessageBox(dx.message, "خطا");
                            }
                        });
                    });

                
            });
    }
    const setButton=function(value, type,accId,userName)
    {
        if (value == '') {
            return <span>آزاد <br/>
                <Link to={"SendTo/" + type + "/" + accId  } >
                    <button className="btn btn-success"> تحویل اکانت </button>
                </Link>
            </span>
        }
        else {
            return <span> {value}
                <br />

                <button type="button" onClick={() => { showDetail(type, accId) }} className="btn btn-warning"> اطلاعات تحویل</button>
                

                <button type="button" onClick={() => { showBack(type, accId) }} className="btn btn-info"> برگشت اکانت</button>

            </span>
        }
    }


    return <FromBasic static="اکانت ها بازی ">
        <div className="col-12">
            <center>
                <div class="col-sm-6">
                    <h3>  {pageState.accs.info.title}<br /></h3>
                    <img height="100px" src={"\\images\\cover\\" + pageState.accs.info.id + ".jpg"}></img>


                </div>
                <div class="col-sm-6">
                    {pageState.accs.info.gameType == '0' &&
                        <span> ظرفیت 2 پلی استیشن 4 :{pageState.accs.z2ps4} آزاد<br />
                        </span>}
                    ظرفیت 2 پلی استیشن 5 :{pageState.accs.z2ps5} آزاد <br />


                    ظرفیت 3   :{pageState.accs.z3} آزاد<br />


                </div>
               
              

            </center>

            <input className="form-control" id="txtFilter" placeholder="برای جست و جو اینجا کلیک کنید" onKeyUp={() => {
                let v = $('#txtFilter').val();

                let st = pageState;
                st.filter = v;
                loadAccounts({ filter: v, accs: pageState.accs, isLoaded: pageState.isLoaded });
            }}></input>
        </div>
      
        {lis.map((x) => {
            return <FromBasic >
                <FormDiv size="25%">
                    نام کاربری:<br/>
                    {x.userName} <br />
                    <Link to={"/Admin/UseBackup/" + x.id} >  <SimpleButton title="استفاده از کدبکاپ"></SimpleButton></Link>

                </FormDiv>
                {pageState.accs.info.gameType == '0' && <FormDiv size="25%">
                  ظرفیت دوم پلی استیشن 4 <br/>
                  {setButton(x.z2ps4, 1, x.id, x.userName)}
              </FormDiv>}
                <FormDiv size="25%">
                    ظرفیت دوم پلی استیشن 5 <br />
                  {setButton(x.z2ps5, 2, x.id, x.userName)}
                </FormDiv>
                <FormDiv size="25%">
                    ظرفیت سوم  <br />
                    {setButton(x.z3, 3, x.id, x.userName)}
                </FormDiv>
            </FromBasic>

        })}
           
     
        


     


    </FromBasic>;
}


export function SetZ(props) {

    const [pageState,setState ]= useState({ baseInfo: {} ,isLoaded:false });
    const params = useParams();

    const  load =function() {
        let h = new Helper();
        h.Ajax("Games", "StartDel", { accId: params.accId, type: params.type }
            , (data) => {
                setState({ isLoaded: true, baseInfo: data[0] });
            }
        )
    }

    const save = function () {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let d = { AccId: params.accId, type: params.type, model: h.GetPostData() }
        h.Ajax('Games', 'SaveGet', d, (data) => {

            if (data.status == "200") {
                h.MessageBox(data.message);
                h.GoBack();
            }
            else {
                h.MessageBox(data.message, "خطا");
            }


        }
         

        )
    }


    if (pageState.isLoaded == false) {
        load();
        return <span>در حال  بارگذاری ...</span>;
    }


    return <FromSubmit submitBev={save}>
        <center>
            {pageState.baseInfo.title} <br />
            {pageState.baseInfo.userName} <br />
            {pageState.baseInfo.password} <br />
            {pageState.baseInfo.backupCodes} <br />
            {pageState.baseInfo.type} <br />
            <Link to="CreateQuickUser" >
            <button className="btn btn-success">ایجاد مشترک سریع </button>

            </Link>
        </center>
        <InputBox meta={DataClass.UsageAcc.delvere} size="33%" />
        <InputBox meta={DataClass.UsageAcc.userId} size="33%" />
        <InputBox meta={DataClass.UsageAcc.startDate} size="33%" />
        <InputBox meta={DataClass.UsageAcc.descr} size="100%" />
    </FromSubmit>

}

export function QuickUserCreate(props) {
    const Save = function () {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let d = h.GetPostData();
        h.Ajax("Games", "QuickUser", { model: d }, (data) => {
            if (data.status == "200") {
                h.MessageBox("مشترک ایجاد شد", "مشترک ایجاد شد");
                h.GoBack();
            }
            else {
                h.MessageBox(data.message,"خطا");
            }
           

        });

    };
    return <FromSubmit submitBev={Save}>
        <InputBox meta={DataClass.User.MobileNo} size="100%" />
        <InputBox meta={DataClass.User.UserFullName} size="100%" />
    </FromSubmit>

}


export class Requests extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { data: null };
    }
    componentDidMount() {
        let h = new Helper();
        let cmd = this;
        h.Ajax('Games', 'Requests', {}, function (data) {
            cmd.setState({ data: data });
        });
    }
    render() {
        let h = new Helper();

        if (this.state.data == null) {
            return <div>در حال بارگذاری</div>
        }
        const Doit = (record) => {
            let hlp = new Helper();
            let cmd = this;
            hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
                hlp.Ajax('Games', 'Doit', { id: record.id }, function (data) {
                    cmd.componentDidMount();
                    hlp.MessageBox(data.message, FixedMessage.Result);
                });
            });
        }

        return <FromBasic>
            درخواست های در جریان <br />
            <ProTable datasourcename="activeRequests" key={Date().toString()} Records={this.state.data}>
                <Column columnName="title" caption="نام بازی" type={ColumnType.DisplayValue} />
                <Column columnName="email" caption="اکانت" type={ColumnType.DisplayValue} />

                <Column columnName="userName" caption="مشترک" type={ColumnType.DisplayValue} />
                <Column metaForDisplay={DataClass.Request.requestType} />
                <Column metaForDisplay={DataClass.UsageAcc.usageType} />

                <Column metaForDisplay={DataClass.Request.createTime} />
                <Column metaForDisplay={DataClass.Request.status} />
                <Action caption="انجام تحویل " Icon="Yes" type="function" columnName="id" showCond={(v) => {return v.requestType==1 } } targetFun={Doit} />
                <Action caption="تخصیص اکانت " Icon="Yes" type="function" columnName="id" showCond={(v) => { return v.requestType == 0 }} targetFun={Doit} />
                <Action caption="برگشت اکانت " Icon="Yes" type="function" columnName="id" showCond={(v) => { return v.requestType == 2 }} targetFun={Doit} />

            </ProTable>
        </FromBasic>;
    }
}


export class Status extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { data: null };
    }
    componentDidMount() {
        let h = new Helper();
        let cmd = this;
        h.Ajax('Home', 'ShareInfo', {}, function (data) {
            cmd.setState({ data: data });
            window.shareInfo = data;
        });
    }
    render() {
        let h = new Helper();

        if (this.state.data == null) {
            return <div>در حال بارگذاری</div>
        }
        const Cancel = (record) => {
            let hlp = new Helper();
            let cmd = this;
            
            hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
                
                hlp.Ajax('Gamer', 'Cancel', { id: record.id }, function (data) {
                    cmd.componentDidMount();
                    hlp.MessageBox(data.message, FixedMessage.Result);
                    window.reloadStatus();
                });
            });
        }
        if (this.state.data.type == "Admin") {
            return <FromBasic>
                درخواست های در جریان <br/>
                <ProTable datasourcename="activeRequests" Records={this.state.data.activeRequests}>
                    <Column columnName="title" caption="نام بازی" type={ColumnType.DisplayValue} />

                    <Column columnName="userName" caption="مشترک" type={ColumnType.DisplayValue} />
                    <Column metaForDisplay={DataClass.Request.requestType} />
                    <Column metaForDisplay={DataClass.Request.createTime} />
                    <Column metaForDisplay={DataClass.Request.status} />
               
                </ProTable>
            </FromBasic>;
        }
        //<ProTable datasourcename="activeRequests" key={Date().toString()} Records={this.state.data.activeRequests}>
        //    <Column columnName="title" caption="نام بازی" type={ColumnType.DisplayValue} />
        //    <Column type={ColumnType.Image} caption="تصویر" columnName="gameId" url="/images/cover/" ext=".jpg" />

        //    <Column metaForDisplay={DataClass.Request.requestType} />
        //    <Column metaForDisplay={DataClass.Request.createTime} />
        //    <Column metaForDisplay={DataClass.Request.status} />
        //    <Action caption="لغو" Icon="Cancel" type="function" columnName="userId" targetFun={Cancel} />
        //</ProTable>
        if (this.props.mode == undefined) {
            return <FromBasic>
                <NewGame />

            </FromBasic>
        }

        return <FromBasic>
            <div className="col-sm-6">
                <h4>طرح فعلی : {this.state.data.planTitle}</h4> 
            </div>
            <div className="col-sm-6">
                <h4>تعداد بازی در اختیار: {this.state.data.gameUsage}</h4>
            </div>




        
            <div class="games-grid">
                {this.state.data.activeRequests.map((v) => {
                    return <div class="game-card" >
                        <img src={"/images/cover/" + v.gameId + ".jpg"}  class="game-image" />
                            <div class="game-info">
                            <h3 class="game-title">{v.title }</h3>
                            <br /><span >
                               <b>نوع درخواست:</b> {h.GetCaptionFromEnum(enums.RequestType, v.requestType)} <br />
                                <b>وضعیت:</b>  {h.GetCaptionFromEnum(enums.RequestStatus, v.status)} <br />
                                <b>تاریخ درخواست:</b>{v.createTime}<br />

                                <button type="button" class="btn btn-danger" onClick={() => {
                                    let x = new Helper();
                                    Cancel(v);


                                }} >لغو</button>
                                </span>
                            </div>
                       </div>



                })}
               
                

            </div>
        
           
        </FromBasic>;
    }
  
}

export class AddRequest extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;

    }
    submit() {
        let h = new Helper();
        h.Validate();
        let cx = document.getElementById('txtfilename');
        if (h.isValidate()) {
            let o = h.GetPostData();
            let formData = new FormData();
            formData.append('title', o.title);
            formData.append('context', o.context);
            for (let i = 0; i < cx.files.length; i++) {
                formData.append('file', cx.files[i], cx.files[i].value);
            }
            h.AjaxForUpload('Request', 'New', formData, function (data) {
                if (data.status == 200) {
                    h.Alert("با موفقیت ثبت شد تا پنچ ثانیه دیگر به صفحه منتقل می شوید");
                    setTimeout(() => { window.location = "/Admin/Req/" + data.refId }, 5000);

                }
                else {
                    h.Error(data.message);
                }
            });

        }
    }



    render() {

        return <FromSubmit submitBev={this.submit} staticTitle="ثبت درخواست جدید">
            <InputBox meta={DataClass.Request.title} size="100%" ></InputBox>
            <InputBox meta={DataClass.Request.context} customHelper={CustomHelper.LongText} size="100%" ></InputBox>
            <InputTextBox model="filename" customHelper={CustomHelper.File} columnName="filename" caption="فایل ضمیمه" multi size="100%" ></InputTextBox>
             

        </FromSubmit>

    }
}

 
export class RequestShow extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.state = { data: [] };
        this.send = this.send.bind(this);
    }
    componentDidMount() {
        let h = new Helper();
        let cmd = this;
        h.Ajax('Request', 'ShowRequest', { id: this.id }, function (data) {
            if (data.status == '500') {
                h.Alert(data.message);
                h.GoBack();
            }

            cmd.setState({ data: data });

        });
    }

    send() {
        let h = new Helper();
        h.Validate();
        let cx = document.getElementById('txtfilename');
        if (h.isValidate()) {
            let o = h.GetPostData();
            let formData = new FormData();
            formData.append('pid', this.id);
            formData.append('context', o.context);
            for (let i = 0; i < cx.files.length; i++) {
                formData.append('file', cx.files[i], cx.files[i].value);
            }
            let cmd = this;
            h.AjaxForUpload('Request', 'Response', formData, function (data) {
                if (data.status == 200) {
                    h.Alert("با موفقیت ثبت شد ");
                    cmd.componentDidMount();
                }
                else {
                    h.Error(data.message);
                }
            });

        }
    }



    render() {

        let ele = [];
        for (let i = 0; i < this.state.data.length; i++) {
            let v = this.state.data[i];
            ele.push(<div style={{ margin: '5px', backgroundColor: (v.isYou ? 'lightblue' : 'white'), padding: '5px', borderRadius: '5px', textAlign: !v.isYou ? 'left' : 'right', boxShadow: '1px 1px 2px black' }}>
                {v.title} توسط {v.isYou?'شما':  v.userFullName} مورخه {v.createTime}
                <br />
                {v.context}
                <br />
                {v.fileNames!=null  && <a href={"/content/Attat/" + v.fileNames} download={v.fileNames} > دریافت ضمیمه </a>} 
            </div>);
            
        }
        return <div><div>{ele}</div><br /><FromSubmit submitBev={this.send}>
            <InputBox meta={DataClass.Request.context}  customHelper={CustomHelper.LongText} size="100%" ></InputBox>
            <InputTextBox model="filename" customHelper={CustomHelper.File} columnName="filename" caption="فایل ضمیمه" multi size="100%" ></InputTextBox>

        </FromSubmit></div>;
        
         
    }

}
export class RegMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
 
        this.Refersh = this.Refersh.bind(this);
        this.Confrim = this.Confrim.bind(this);
        this.Deny = this.Deny.bind(this);
    }

    Confrim(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Games', 'Confrim', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }
    Deny(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Games', 'Deny', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }
    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Games', 'RegList', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                 <ProTable Records={this.state.Records} datasourcename='Regs'>

                    <Column caption="طرح" columnName="planTitle" type={ColumnType.DisplayValue} />
                  
                    <Column metaForDisplay={DataClass.Reg.timeDurrion} />
                    <Column metaForDisplay={DataClass.Reg.console} />
                    <Column metaForDisplay={DataClass.Reg.gameCount} />
                    <Column metaForDisplay={DataClass.Reg.price} />
                    <Column metaForDisplay={DataClass.Reg.mobile} />
                    <Column metaForDisplay={DataClass.Reg.fullName} />
                    <Column metaForDisplay={DataClass.Reg.natCode} />
                    <Column metaForDisplay={DataClass.Reg.payMethod} />
                    <Column metaForDisplay={DataClass.Reg.status} />

        

                    <Action caption="تایید ثبت نام" Icon="Yes" type="function" targetFun={this.Confrim} />
                    <Action caption="عدم تایید ثبت نام" Icon="No" type="function" targetFun={this.Deny} />




                </ProTable>
            </FromBasic>
        }
    }



}
export class Regit extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            level: 0, planId: 0, conso: 0, plans: [], game: [], prices: [], selectedPrice: {} ,priceIndex:-1 };
        
    }
    componentDidMount() {
        this.loadData();
    }
    loadData() {
        let s = this.state;
        let h = new Helper();
        let cmd = this;
        h = h.Ajax('Home', 'AllPlan', {}, (data) => {
            s.plans = data;
            cmd.setState(s);

        });
    }
    loadGames() {
        let s = this.state;
        let h = new Helper();
        let cmd = this;
        h = h.Ajax('Home', 'AllGameOfPlan', { id: this.state.planId }, (data) => {
            s.game = data;
            cmd.setState(s);

        });
    }
    loadPrice() {
        let s = this.state;
        let h = new Helper();
        let cmd = this;
        h = h.Ajax('Home', 'AllPriceOfPlan', { planTitle:'',planId: this.state.planId, console: this.state.conso }, (data) => {
            s.prices = data;
            cmd.setState(s);

        });
    }
    selectConsole(conType) {
        let s = this.state;
        s.level += 1;
        s.conso = conType;
        this.setState(s);
    }
    reg() {
        let h = new Helper();
        h.Validate();
        if (this.state.selectedPrice == null) {
            h.errors.push("لطفا یک گزینه برای طرح انتخاب کنید");
        }
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetPostData();
        var keys = Object.keys(this.state.selectedPrice);
        for (var l = 0; l < keys.length; l++)
        {
            data[keys[l]] = this.state.selectedPrice[keys[l]];
        }
        let cmd = this;
        let paymethod = data.payMethod;
        h.Ajax('Home', 'Reg', data, (data)=>{
            if (data.status == '200') {
                h.Alert(data.message);
                let s = cmd.state;
                if (paymethod == '2') {
                    window.open("/sp/" + data.refId);
                }
                s.level = 3;
                cmd.setState(s);
            }
            else {
                h.Error(data.message);
            }
        });
    }
    render() {
        let h = new Helper();
        return <div style={{color:'black'} }>
            <div style={{ position: 'fixed', background: 'url(/backgrounds/Bk.jpg)', backgroundSize: 'cover', left: '0px', top: '0px', zIndex: '-10', bottom: '0px', right: '0px' }} />
            <center>
                <img alt="window.config.AppTitle" src="/Icons/Logo.png"></img>

                <div className="col-sm-5" style={{ background: 'white', borderRadius: '5px', boxShadow: '1px 1px 3px black' }} role="alert">

                    <FromBasic staticTitle='ثبت نام' >



                        {this.state.level == 0 &&
                            <span>
                             
                                لطفا نوع دستگاه خود را انتخاب کنید <br />
                                <button className="col-sm-6 btn" type="button" onClick={() => { this.selectConsole(0); }} style={{ border: '1px solid ', borderRadius: '5px' }}>
                                    <img src="/images/ps4.jpg" height="80px"></img>
                                <br/>
                                پلی استیشن 4
                                </button>
                                <button className="col-sm-6  btn" type="button" onClick={() => { this.selectConsole(1); }} style={{ border: '1px solid ', borderRadius: '5px' }}>
                                    <img src="/images/ps5.jpg" height="80px"></img>
                                    <br />
                                    پلی استیشن 5
                                </button>
                            </span>
                        }
                        {this.state.level == 1 &&
                            <span>

                              لطفا نوع طرح را انتخاب کنید <br />

                                <br />
                                {this.state.plans.map((v) => {
                                    return <span> <SimpleButton Icon={v.id == this.state.planId ? "Yes" : undefined} title={v.title} onClick={() => {
                                        let s = this.state;
                                        s.planId = v.id;
                                        s.planTitle = v.title;
                                        this.setState(s);
                                        this.loadGames();
                                    }}  ></SimpleButton>
                                    <br/>
                                    </span>
                                  
                                })}


                                <center>
                                    <button className="btn btn-light" type="button" onClick={() => { if (this.state.planId <= 0) { h.Alert("لطفا یک طرح انتخاب کنید"); } let s = this.state; s.level = 2; this.setState(s); this.loadPrice(); }}>
                                    ادامه
                                </button>
                                <button className="btn btn-light" type="button" onClick={() => { let s = this.state; s.level = 0; this.setState(s); }}>
                                   بازگشت
                                    </button>
                                    <FromBasic>
                                    {this.state.game.map((v) => {
                                        return <div className="col-sm-6">
                                            {v.title} <br />
                                            <img width="80px" src={"/images/cover/" + v.id + ".jpg"} ></img>
                                             
                                        </div>
                                    })}
                                    </FromBasic>
                                </center>
                            </span>
                        }
                        {this.state.level == 2 &&
                            <span style={{ textAlign:'right' }}>

                                لطفا مشخصات زیر پر کنید <br />

                                <br />
                                نوع دستگاه : {h.GetCaptionFromEnum(enums.GameType, this.state.conso)} طرح انتخابی : {this.state.planTitle }
                                <br />
                                {this.state.prices.map((v) => {
                                    return <span> <SimpleButton Icon={v == this.state.selectedPrice ? "Yes" : undefined} title={h.GetCaptionFromEnum(enums.TimeDurrion, v.timeDurrion) + " تعداد بازی همزمان  " + v.gameCount} onClick={() => {
                                        let s = this.state;
                                        s.selectedPrice = v;
                                        this.setState(s);
                                    }}  ></SimpleButton>
                                    <br/>
                                    </span>
                                })}
                             
                                <InputBox meta={DataClass.Reg.mobile} size="100%" />
                                <InputBox meta={DataClass.Reg.fullName} size="100%" />
                                <InputBox meta={DataClass.Reg.payMethod} size="100%" />
                                <InputBox meta={DataClass.Reg.natCode} minlength='10' size="100%" />

                                <h2>
                                    مبلغ قابل پرداخت: {h.addCommas(this.state.selectedPrice.price)} ریال</h2> <br/>
                                    شماره کارت جهت پرداخت :6104337961803788 علی حسینی پور
                                <center>
                                    <button className="btn btn-light" type="button" onClick={() => { this.reg() }}>
                                        ثبت نام
                                    </button>
                                    <button className="btn btn-light" type="button" onClick={() => { let s = this.state; s.level = 0; this.setState(s); }}>
                                        بازگشت
                                    </button>
                             
                                </center>
                            </span>
                        }
                        {this.state.level == 3 &&
                            <span>
                              ثبت نام شما با موفقیت انجام شد جهت ادامه به فروشگاه مراجعه کنید
                              <br/>
                                <Link to="/Login">
                                  بازگشت

                                </Link>


                            </span>
                            }
                    </FromBasic>
                    <Link to="/" id="Startup" ></Link>
                    <Link to="/Admin/Index.html" id="AdminPage" ></Link>
                    طراحی و اجرا :پرویز بازگشا
                </div>
            </center>
            <Model />
            <Confirm />
            <AjaxStatus />
        </div>;
    }
}

export class RegFTTH extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            level: 0, planId: 0, conso: 0, plans: [], game: [], prices: [], selectedPrice: {}, priceIndex: -1
        };

    }
    componentDidMount() {
      
    }
    
    render() {
        let h = new Helper();
        return <div style={{ color: 'black' }}>
            <div style={{ position: 'fixed', background: 'url(/backgrounds/Bk.jpg)', backgroundSize: 'cover', left: '0px', top: '0px', zIndex: '-10', bottom: '0px', right: '0px' }} />
            <center>
               

                <div className="col-sm-7" style={{ background: 'white', borderRadius: '5px', boxShadow: '1px 1px 3px black' }} role="alert">

                    <FromBasic staticTitle='ثبت نام فیبرنوری' >
                        <ShowFixedPage id={"ثبت نام فیبرنوری" } />
                        <AddFTTHRequest />
                    </FromBasic>
                    <Link to="/" id="Startup" ></Link>
                    <Link to="/Admin/Index.html" id="AdminPage" ></Link>
                    طراحی و اجرا :پرویز بازگشا
                </div>
            </center>
            <Model />
            <Confirm />
            <AjaxStatus />
        </div>;
    }
}


const MenuButton = () => {
 

    const handleClick = () => {
        $('#sideMenu').css('width', '300px');
        $('#sideBack').show();
    };

    return (
        <button title="منو اصلی"
            onClick={handleClick}
            style={{
                position: 'fixed',
                bottom: '80px',
                left: '20px',
                backgroundColor: '#4e54c8', // رنگ سبز واتساپ
                color: 'white',
                width:'48px',height:'48px',
                fontSize: '20px',
                padding: '12px',
                border: 'none',
                borderRadius: '50%',
                cursor: 'pointer',
                boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center', zIndex:'5'
            }}
        >
            ...
        </button>
    );
};



const WhatsAppButton = () => {
    const phoneNumber = '+989177792026'; // شماره را بدون علامت + وارد کن
    const message = 'سلام!';

    const handleClick = () => {
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    return (
        <button title="پشتیبانی"
            onClick={handleClick}
            style={{
                position: 'fixed',
                bottom: '20px',
                left: '20px',
                backgroundColor: '#4e54c8', // رنگ سبز واتساپ
                color: 'white',
                fontSize: '20px',
                padding: '12px',
                border: 'none',
                borderRadius: '50%',
                cursor: 'pointer',
                boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center', zIndex:'5'
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                width="24"
                viewBox="0 0 24 24"
                fill="white"
            >
                <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.14-.21c1.26.5 2.63.78 4.05.78a1 1 0 011 1V20a1 1 0 01-1 1C10.85 21 3 13.15 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.42.28 2.79.78 4.05a1 1 0 01-.21 1.14l-2.2 2.2z" />
            </svg>
        </button>
    );
};

class ForgetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { level: 0, userId: '' };
        this.forgetPassword = this.forgetPassword.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }


    forgetPassword() {
        let cmd = this;
        let h = new Helper();
        h.Validate();
        if (h.isValidate()) {
            let o = h.GetPostData();
            h.Ajax('Home', 'forgetPassword', o, function (data) {
                if (data.status == '200') {
                    cmd.setState({ level: 1, userId: o.userName });
                    h.Alert(data.message);
                }
                else {
                    h.Alert(data.message);
                }

            })
        }
        
    }
    changePassword() {
        let cmd = this;
        let h = new Helper();
        h.Validate();
        if (h.isValidate()) {
            let o = h.GetPostData();
            o.userName = this.state.userId;
            h.Ajax('Home', 'changePwd', o, function (data) {
                if (data.status == '200') {
                    h.Alert(data.message);
                    setTimeout(() => { $('#login')[0].click() }, 2000);
                }
                else {
                    h.Alert(data.message);
                }

            })
        }

    }


    render() {
       
        return <div style={{ color: 'black' }}>
            <WhatsAppButton></WhatsAppButton>
            <div style={{ position: 'fixed', color: 'black',  background: 'url(/backgrounds/Bk.jpg)', backgroundSize: 'cover', left: '0px', top: '0px', zIndex: '-10', bottom: '0px', right: '0px' }} />
                <center>
                    <img alt="window.config.AppTitle" src="/Icons/Logo.png"></img>
                    
                    <div className="col-sm-5" style={{ background: 'white', borderRadius: '5px', boxShadow: '1px 1px 3px black' }} role="alert">

                        <FromBasic staticTitle='فراموشی گذر واژه' >



                            {this.state.level==0 &&
                            <center>

                              
                                <InputTextBox caption='شناسه کاربری' size='100%' columnName='userName' mustFill='yes' />
                                
                                <br />
                                
                                
                                <br />
                                    <button type="button" className="btn btn-primary" onClick={this.forgetPassword}   ><Icon Icon="Sec" /> ارسال پیامک رمز موقت </button>
                                <SimpleButton Icon="Cancel" title="بازگشت" onClick={() => {
                                    window.location = "/Login";
                                }} ></SimpleButton>
                                </center>
                            }
                            {this.state.level == 1 &&
                                <center>
                                    <InputBox meta={DataClass.MobileVerify.VerfiyCode} size='100%' ></InputBox>
                                    <InputPasswordBox size='100%' mustFill="Yes" minlength='6' columnName='Password' caption='گذرواژه' />
                                    <InputPasswordBox size='100%' mustFill="Yes" minlength='6' columnName='PasswordRepeat' equalValue='Password' caption='تکرار گذرواژه' />

                               
                                    <br />

                                   
                                    <br />
                                    <button type="button" className="btn btn-primary" onClick={this.changePassword}   ><Icon Icon="Sec" />  {FixedMessage.Login}</button>
                                    <SimpleButton Icon="Cancel" title="بازگشت" onClick={() => {
                                        window.location = "/Login";
                                    }} ></SimpleButton>
                                    <Link to="/Login" id="login" />
                                </center>
                            }


                        </FromBasic>
                        <Link to="/" id="Startup" ></Link>
                        <Link to="/Admin/Index.html" id="AdminPage" ></Link>
                      طراحی و اجرا :پرویز بازگشا
                    </div>
                </center>
                <Model />
                <Confirm />
                <AjaxStatus />
            </div>;
        }
}



 function ClientPanel(props) {
    
    return <div>


        

        <div style={{ background: 'white', boxShadow: '1px 1px 2px black' }}>  <Outlet />
            <hr />
            <center>
               طراحی و اجرا :پرویز بازگشا

            </center>
            <Link to="/Client\LabSelect" id="startMobile" />
        </div>


        <Model />
        <Confirm />

        <AjaxStatus />
        <FileProgess />
    </div>

}



function TaminLogo() {
    return <div style={{ width: '100%', height: '120px', backgroundImage: 'linear-gradient(white,lightblue)', boxShadow: 'inset 1px 1px 5px white' }}>
        <FromBasic>
            <FormDiv size='50%'>
                
        </FormDiv>
            <FormDiv size='50%'>
              <center>
                <h2>سازمان تامین اجتماعی</h2>
                    <h4>سامانه درخواست های فن آوری</h4>
                </center>
            </FormDiv>
        </FromBasic>
    </div>;
}
window.menu = null;
window.menu2 = null;
class AdminPanel extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;
    }

    componentDidMount() {
        setTimeout(this.setMenuItem, 5000);
    }
     setMenuItem = () => {
        let h = new Helper();
         h.Ajax('Home', 'ShareInfo', {}, (data) => {
             window.shareInfo = data;
             for (let i = 0; i < data.summerys.length; i++) {
                 var d = data.summerys[i];
                 if (d.count == 0) {
                     $('[linkpoint="' + d.link + '"]').html("");

                 }
                 else {
                     $('[linkpoint="' + d.link + '"]').html("<span class='natCounter'>" + d.count + "</span>");

                 }
                        }

           
          
        });

         setTimeout(this.setMenuItem, 60000);
    };

    render() {
      


        let Props = this.props;
        return <div>
            <WhatsAppButton></WhatsAppButton>
            <Header />
            <div className="row">
              
                <div className="col-12 col-md-12" style={{ boxShadow: '1px 1px 2px gray', borderRadius: '5px' }}>
                    <Outlet></Outlet>
                </div>


            </div>
            <div id="sideBack" onClick={() => { $('#sideMenu').css('width', '0px'); $('#sideBack').hide(); }} style={{ display: 'none', position: 'fixed', left: '0px', top: '0px', bottom: '0px', right: '0px', zIndex: '9', background: 'black', opacity: '0.5' }}>


            </div>
            <MenuButton/>
            <div id="sideMenu" style={{overflow:'scroll', transition: 'width 0.5s',color:'black' ,position: 'fixed', right: '0px', top: '0px', bottom: '0px', width: '0px', zIndex: '10', background: 'white' }}>
                <a style={{ cursor: 'pointer' }} onClick={() => { $('#sideMenu').css('width', '0px'); $('#sideBack').hide(); }}><Icon Icon="bi-x-lg"></Icon>  </a> <br />
                
                    <Menu id="Menu">
                     
                    </Menu>
               
            </div>



            <hr />
            <center>
                طراحی و اجرا پرویز بازگشا

            </center>
            <Model />
            <Confirm />
            <Link to="/Login" id="LoginLink" ></Link>
            <AjaxStatus />
            <FileProgess />
        </div>;


    }
}


function Header(props) {
    return <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
            <div style={{color:'black'} } > <h3><Icon Icon="Logo" ></Icon>   {window.config.AppTitle}</h3></div>

           



        </div>
    </nav>;

}

function BasePage(props) {
    return <div ><Outlet></Outlet></div>


      console.log(Math.random());
    return <div>
        <Header />
        <div className="row">
            <div className="col-12 col-md-3  d-none d-sm-none d-md-block" style={{ boxShadow: '1px 1px 2px gray', borderRadius: '5px' }}>
                <Menu> </Menu>
            </div>
            <div className="col-12 col-md-9" style={{ boxShadow: '1px 1px 2px gray', borderRadius: '5px' }}>
                <Outlet />
            </div>


        </div>
        <div id="sideMenu" style={{ transition: 'width 0.5s', position: 'fixed', left: '0px', top: '0px', bottom: '0px', width: '0px', zIndex: '10', background: 'white' }}>
            <a style={{ cursor: 'pointer' }} onClick={() => { $('#sideMenu').css('width', '0px') }}><Icon Icon="bi-x-lg"></Icon>  </a> <br />
            <Menu />

        </div>



        <hr />
        <center>
            طراحی و اجرا پرویز بازگشا

        </center>
        <Model />
        <Confirm />

        <AjaxStatus />
        <FileProgess />
    </div>;


}
 


function AjaxStatus(props) {
    return <div id='AjaxStatus' style={{ position: 'fixed', left: '0px', bottom: '0px', display: 'none' }}>
        <LoadingBar /> {FixedMessage.PleaseWait}
        </div>

}


 
class UserMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.DeleteUser = this.DeleteUser.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }
    componentDidMount() {
        if (this.state.isLoaded == false) {
            this.Refersh(false); 

        }


    }
    ResetPassword(rec) {
        let com = this;
        let help = new Helper();
        help.ConfirmAction(FixedMessage.AreYouSure, "پرسش", function () {
            help.Ajax('User', 'ResetPassword', rec, function (e) {
                help.Alert(FixedMessage.NoProblem, 'نتیجه');
                com.setState({ isLoaded: false, Records: [] });
                com.Refersh(false);
            }
                , function (e) { help.Error(FixedMessage.ErrorRaise, 'نتیجه'); })
        });

    }
    Refersh(everyone) {
        let com = this;
        new Helper().Ajax('User', 'List', { everyone: everyone },
            function (Result) {
                com.setState({ isLoaded: true, Records: Result });
            }, function (err) { }
        );


    }
    DeleteUser(rec) {
         let com = this;
        let help = new Helper();
        help.ConfirmAction(FixedMessage.AreYouSure, "پرسش", function () {
            help.Ajax('User', 'Delete', rec, function (e) {
                help.Alert(FixedMessage.NoProblem, 'نتیجه');
                com.setState({ isLoaded: false, Records: [] });
                com.Refersh(false);
            }
                , function (e) { help.Error(FixedMessage.ErrorRaise, 'نتیجه'); })
        });

    }

    render() {
        return <FromBasic staticTitle='مدیریت کاربران'> <center>لیست کاربران
        <br />
            <AddButton title="کاربر" entity="User" />
            <SimpleButton title="همه کاربران" onClick={() => { this.Refersh(true); }} ></SimpleButton>
            <br/>
            {this.state.isLoaded == false &&
                 <LoadingBar /> 
            }
            {this.state.isLoaded == true &&
                <ProTable Records={this.state.Records} datasourcename='UserList'><Column type={ColumnType.DisplayValue} columnName='userId' ref={this.refs} caption='شناسه کاربری' ></Column>
                <Column type={ColumnType.DisplayValue} columnName='userFullName' caption='نام کاربر' ref={this.refs} ></Column>
                <Column metaForDisplay={DataClass.User.sex} width={200} />
                <Column metaForDisplay={DataClass.User.actived} width={200} />
                    <Action caption="تغییر گذرواژه" Icon="Password" type="function" targetFun={this.ResetPassword } pageName="/User" columnName="userId" />

                <Action caption="ویرایش" Icon="Edit" type="Link" pageName="/User" columnName="userId" />
                    <Action caption="درج تصویر" Icon="Upload" type="Link" pageName="/UploadImageObj/User" columnName="userId" />

                    <Action caption="حذف" Icon="Delete" type="function" columnName="userId" targetFun={this.DeleteUser} />
                </ProTable>} </center></FromBasic>;
        

    }
       
    
}

class AddUser extends React.Component {
     Submit()
     {
         let helpCls = new Helper();

         let o = helpCls.GetPostData();
         let data = { Model: o, roles: $('#txtRoles').val() };
         helpCls.Validate();
          
         if (helpCls.isValidate() == false) {

             return false;
         }
         helpCls.Ajax('User', 'Insert', o, function (s) {
            
             helpCls.Alert('با موفقیت ثبت گردید', 'اطلاعات');
             helpCls.GoBack();

         }, function (e) {
             console.log(JSON.stringify(e));
             helpCls.Error('خطا در ثبت', 'خطا');
         })
    }



    render() {
        return <FromSubmit staticTitle='کاربر جدید' submitBev={this.Submit}>

            <InputBox meta={DataClass.User.UserId} size='50%' />
            <InputBox meta={DataClass.User.UserFullName} size='50%' />
            <InputBox meta={DataClass.User.MobileNo} size='50%' />
            <InputBox meta={DataClass.User.Email} size='50%' />
            <InputPasswordBox size='50%' mustFill="Yes" minlength='6' columnName='Password' caption='گذرواژه' />
            <InputPasswordBox size='50%' mustFill="Yes" minlength='6' columnName='PasswordRepeat' equalValue='Password' caption='تکرار گذرواژه' />
     
            <InputBox meta={DataClass.User.sex} size='50%' />
            <InputBox meta={DataClass.User.actived} size='50%' />
        
            <DropDownBox multi={true} caption="نقش های این کاربر" columnName="roles"  size="100%" mustFill={"yes"} entity="role" />



        </FromSubmit >;
    }

}

class UpdateUser extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.UserId = this.props.UserId;
        this.Submit = this.Submit.bind(this);
    }
    componentDidMount() {
        let helpCls = new Helper();
        helpCls.Ajax('User', 'GetUser', { UserId: this.UserId },
            function (e) {
                helpCls.SetDataBack(e);
            }, function (f) { }
        );

    }

    Submit() {
        let helpCls = new Helper();

        let o = helpCls.GetPostData();
        o.UserId = this.UserId
        let data = { Model: o };
        helpCls.Validate();
       
        if (helpCls.isValidate() == false) {

            return false;
        }
        helpCls.Ajax('User', 'Update', o, function (s) {

            helpCls.Alert('با موفقیت ثبت گردید', 'اطلاعات');
            helpCls.GoBack();

        }, function (e) {
            console.log(JSON.stringify(e));
            helpCls.Error('خطا در ثبت', 'خطا');
        })
    }



    render() {
        return <FromSubmit staticTitle={'ویرایش کاربر' + ' ' + this.UserId} submitBev={this.Submit}>


            <InputTextBox size='50%' columnName='UserFullName' mustFill="Yes" initValue="userFullName" caption='نام کاربر' />
            <InputTextBox size='50%' mustFill="Yes" columnName='Email'  initValue="email" email='yes' caption='پست الکترونیک' />
            <InputTextBox size='50%' mustFill="Yes" columnName='MobileNo' initValue="mobileNo" caption='شماره موبایل' />
             
            <InputBox meta={DataClass.User.sex} size='50%' />
            <InputBox meta={DataClass.User.actived} size='50%' />
            
        </FromSubmit >;
    }

}
export function AccUsageTrnReport(props) {

    const [pageState, loadState] = useState({ records: [] });

    const serach = () => {
        let h = new Helper();
        let d = h.GetPostData();
        h.Ajax('Games', 'AccTrnReport', d, (data) => {
            loadState({ records: data });
        });
          
    };




    return <FromBasic static="گزارش استفاده اکانت ها">
        <InputBox meta={DataClass.UsageAcc.AccId} includeAll={true} size="33%" />
        <InputBox meta={DataClass.Account.GameId} includeAll={true} size="33%" />
        <InputBox meta={DataClass.UsageAcc.userId} includeAll={true} size="33%"  />
        <InputBox meta={DataClass.UsageAcc.delvere} includeAll={true } size="33%" />
        <InputBox meta={DataClass.UsageAcc.usageType} includeAll={true} size="33%" />

        <InputBox meta={DataClass.User.actived} caption="آیا برگشت خورده" includeAll={true} size="33%" />
        <InputTextBox columnName="lowerRange" size="33%" caption="میزان استفاده کمتر از" model="lowerRange" />

        <SimpleButton icon="view" onClick={serach} title="جست و جو" ></SimpleButton>
        <ProTable Records={pageState.records} datasourcename='UsageAccs'>

            <Column type={ColumnType.DisplayValue} caption="نام بازی" columnName="gameTitle" />

            <Column type={ColumnType.DisplayValue} caption="اکانت" columnName="email" />
            <Column type={ColumnType.DisplayValue} caption="مشترک" columnName="userName" />
            <Column metaForDisplay={DataClass.UsageAcc.usageType} />
            <Column type={ColumnType.DisplayValue} caption="روز استفاده" columnName="datediff" />

         
            <Column metaForDisplay={DataClass.UsageAcc.startDate} />
            <Column metaForDisplay={DataClass.UsageAcc.endDate} />
            <Column metaForDisplay={DataClass.UsageAcc.delvere} />
            <Column metaForDisplay={DataClass.UsageAcc.descr} />
            <Action caption="ویرایش" Icon="Edit" type="Link" pageName="/UpdateUsageAcc" columnName="id" />


        </ProTable>
    </FromBasic>
}
class RoleMgt extends Component
{
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.DeleteRole = this.DeleteRole.bind(this);
    }
    componentDidMount() {
        if (this.state.isLoaded == false) {
            this.Refersh();
        }


    }
    DeleteRole(rec) {
        let com = this;
        let help = new Helper();
        help.ConfirmAction("مطممنید؟", "پرسش", function () {
            help.Ajax('Role', 'Delete', rec, function (e) {
                help.Alert('با موفقیت حذف شد', 'نتیجه');
                com.setState({ isLoaded: false, Records: [] });
                com.Refersh();
            }
                , function (e) { help.Error('خطا در حذف', 'نتیجه'); })
        });

    }


    Refersh() {
        console.log('ref');
        let com = this;
        new Helper().Ajax('Role', 'List', {},
            function (Result) {
                let helpe = new Helper();
                
                com.setState({ isLoaded: true, Records: Result });
            }, function (err) { }
        );


    }
    SaveBatch() {
        let helpe = new Helper();
        helpe.Validate();

        if (helpe.isValidate() == false) {
            return;
        }
        let list = helpe.GetDataGrouped(window.RoleList);
        let cmd = this;
        let Data = { Changed: list[RowState.Changed] };
        helpe.Ajax('Role', 'BatchSave', Data, function (data) {
            helpe.Alert(FixedMessage.NoProblem, FixedMessage.Result);
            cmd.Refersh();
        }
        );

    }
    render() {
        return  <FromBasic staticTitle='مدیریت نقش ها'> <center>لیست نقش ها
        <br />
            <AddButton title="نقش" entity="Role" />
             <br />
            {this.state.isLoaded == false &&
                <LoadingBar />
            }
            {this.state.isLoaded == true &&
                <ProTable datasourcename='RoleList' Records={this.state.Records}>  
                <Column metaForDisplay={DataClass.Role.Id}  ></Column>
                <Column metaForDisplay={DataClass.Role.RoleName} ></Column>
                <Column metaForDisplay={DataClass.Role.Descr} ></Column>
                <Action caption="ویرایش" Icon="Edit" type="Link" pageName="/Role" columnName="id" />
                <Action caption="تعیین مجوز ها" type="Link" Icon="Permisson" pageName="/Role_SetPermission" columnName="id" />
                <Action caption="تعیین کاربران " Icon="Users" type="Link" pageName="/Role_SetUser" columnName="id" />
                <Action caption="حذف" type="function" Icon="Delete" columnName="id" targetFun={this.DeleteRole} />
                </ProTable>} </center></FromBasic>
        
             ;

    }

}


class AddRole extends Component {

      RoleId = -1;

    constructor(props) {
        super(props)
        this.props = props;
        this.Submit = this.Submit.bind(this);
        this.RoleId = this.props.RoleId;
    }
    componentDidMount() {
        let helpCls = new Helper();
        helpCls.Ajax('Role', 'Get', { id: this.RoleId },
            function (e) {
                helpCls.SetDataBack(e);
            }, function (f) { }
        );

    }
    Submit() {
        let helpCls = new Helper();

        let o = helpCls.GetPostData();
        let data = { Model: o };
        data.RoleId = this.props.RoleId;
        helpCls.Validate();

        if (helpCls.isValidate() == false) {

            return false;
        }
        helpCls.Ajax('Role', 'SaveRecord', data, function (s) {

            helpCls.Alert('با موفقیت ثبت گردید', FixedMessage.Result);
            helpCls.GoBack();

        }, function (e) {
            console.log(JSON.stringify(e));
            helpCls.Error('خطا در ثبت', 'خطا');
        })
    }
    
    render() {

        return  <FromSubmit staticTitle={(this.RoleId == -1 ? 'نقش جدید' : 'ویرایش نقش')} submitBev={this.Submit}>
            <InputBox meta={DataClass.Role.RoleName} size='100%' />
            <InputBox meta={DataClass.Role.Descr} size='100%' />

        </FromSubmit >;
    }

}


class Role_SetPermissions extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.RoleId = this.props.RoleId;
        this.state = { Records: [], isLoaded: false };
        this.Submit = this.Submit.bind(this);
    }
    componentDidMount() {
        let helpCls = new Helper();
        let cmd = this;
        helpCls.Ajax('Role', 'Get_Permissons', { id: this.RoleId },
            function (e) {
                console.log('Data Loaded!');
                cmd.setState({ isLoaded: true, Records: e });
            }, function (f) {
                console.log('Error');
            }
        );

    }
    Submit() {
        let hel = new Helper();
        let d = {
            id: this.RoleId,
            Pers: hel.GetRecordWithCircita(window.Pers, 'selected', true)
        };
            let cmd=this;
        hel.Ajax('Role', 'Set_Pers', d,
            function (data) {
                hel.Alert(FixedMessage.NoProblem, FixedMessage.Result);
                hel.GoBack();
            }
            , function (err) {
                hel.Error(FixedMessage.ErrorRaise, FixedMessage.Result);
            }

        )
            

    }
    render() {
        if (this.state.isLoaded == false) {
            return  <LoadingBar />;
        }
        else {
            return <FromSubmit staticTitle='تعیین مجوز ها' submitBev={this.Submit} >
               


                <ProTable Records={this.state.Records} datasourcename='Pers'>
                    <Column type={ColumnType.DisplayValue} columnName='permission_Id' caption='شناسه مجوز' />
                    <Column type={ColumnType.DisplayValue} columnName='permission_Title' caption='عنوان مجوز' />
                    <Column type={ColumnType.DisplayValue} columnName='permission_Descr' caption='توضیحات مجوز' />
                    <Column type={ColumnType.InputCheck} columnName='selected'  />
                </ProTable>
            </FromSubmit>
             

        }

    }

}





class Role_SetUser extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.RoleId = this.props.RoleId;
        this.state = { Records: [], isLoaded: false };
        this.Submit = this.Submit.bind(this);
    }
    componentDidMount() {
        let helpCls = new Helper();
        let cmd = this;
        helpCls.Ajax('Role', 'Get_Users', { id: this.RoleId },
            function (e) {
                console.log('Data Loaded!');
                cmd.setState({ isLoaded: true, Records: e });
            }, function (f) {
                console.log('Error');
            }
        );

    }
    Submit() {
        let hel = new Helper();
        let d = {
            id: this.RoleId,
            users: hel.GetRecordWithCircita(window.Users, 'selected', true)
        };
        let cmd = this;
        hel.Ajax('Role', 'Set_User', d,
            function (data) {
                hel.Alert(FixedMessage.NoProblem, FixedMessage.Result);
                hel.GoBack();
            }
            , function (err) {
                hel.Error(FixedMessage.ErrorRaise, FixedMessage.Result);
            }

        )


    }
    render() {
        if (this.state.isLoaded == false) {
            return <LoadingBar />;
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true}  staticTitle='تعیین مجوز ها' SubmitButtonOnTop={true}  submitBev={this.Submit} >



                <ProTable Records={this.state.Records} datasourcename='Users'>
                    <Column type={ColumnType.DisplayValue} columnName='userId' caption='شناسه کاربری' />
                    <Column type={ColumnType.DisplayValue} columnName='userFullName' caption='نام کاربری' />
                      <Column type={ColumnType.InputCheck} columnName='selected' />
                </ProTable>
            </FromSubmit>

        }

    }

}
class ChangePassForMySelf extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.Submit = this.Submit.bind(this);
    }
    Submit() {
        let Hlp = new Helper();
        Hlp.Validate();
        if (Hlp.isValidate() == true) {
            let o = Hlp.GetPostData();
            Hlp.Ajax('User', 'ChangePass', o, function (e) {
                Hlp.Alert(e.message, FixedMessage.Result);
                if (e.status == 200) {
                    Hlp.GoBack();
                }
            }, function (e) {

            });
        }
    }
    render() {
        return  <FromSubmit staticTitle="تغییر گذرواژه" submitBev={this.Submit}  >
            <InputPasswordBox size='100%' mustFill="Yes" minlength='6' columnName='oldPassword' caption='گذرواژه کنونی' />
            <InputPasswordBox size='100%' mustFill="Yes" minlength='6' columnName='Password' caption='گذرواژه' />
            <InputPasswordBox size='100%' mustFill="Yes" minlength='6' columnName='PasswordRepeat' equalValue='Password' caption='تکرار گذرواژه' />

        </FromSubmit>
        

    }

}


  


 


 
 
 
 
const MobileLevelVerfiy = { CheckAccessCode:0 ,InputMobile: 1, InputVerfiy: 2 ,SelectLab:3 };
 

 
 
class UploadProfile extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { image: '/Icons/Doctor.png' };
        this.save = this.save.bind(this);
    }
    save() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        let formData = new FormData();
        let cx = document.getElementById('txtfil')
        formData.append('file', cx.files[0], cx.value);
          if (h.isValidate() == true) {
              h.AjaxForUpload('Home', 'UploadProfile', formData, function (data) {
                  h.MessageBox(data.message, '');
                  if (data.status == '200') {
                      h.GoBack();
                  }
            });
        }
    }
    componentDidMount() {
        let h = new Helper();
        let cmd = this;
        h.Ajax('Home', 'GetLoginInfo', {},
            function (data) {
                cmd.setState({ image: data.imgSrc });
            });
    }


    render() {
        return  <FromSubmit submitBev={this.save}>
            <FormDiv size='100%' >
            تصویر فعلی <br></br>
                <img style={{ width: '90px' }} alt="تصویر امنیتی" src={this.state.image}></img>
                <InputTextBox columnName='fil' caption='فایل' mustFill='yes' model='file' size='100%' customHelper={CustomHelper.File} ></InputTextBox>
            </FormDiv>

        </FromSubmit>
    }
}


export class UploadImageObj extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.type = props.type;
        this.id = props.id;
        this.state = { image: '' };
        this.save = this.save.bind(this);
    }
    save() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        let formData = new FormData();
        let cx = document.getElementById('txtfil')
        formData.append('file', cx.files[0], cx.value);
        formData.append('id', this.id);
        formData.append('type', this.type);
        if (h.isValidate() == true) {
            h.AjaxForUpload('Home', 'UploadImageObj', formData, function (data) {
                h.MessageBox(data.message, '');
                if (data.status == '200') {
                    h.GoBack();
                }
            });
        }
    }
    componentDidMount() {
        let h = new Helper();
        let cmd = this;
        h.Ajax('Home', 'GetImageObj', {id:this.id,type:this.type},
            function (data) {
                cmd.setState({ image: data.imgSrc });
            });
    }


    render() {
        return <FromSubmit submitBev={this.save}>
            <FormDiv size='100%' >
                تصویر فعلی <br></br>
                <img style={{ width: '90px' }} alt="تصویری تعیین نشده است" src={this.state.image}></img>
                <InputTextBox columnName='fil' caption='فایل' mustFill='yes' model='file' size='100%' customHelper={CustomHelper.File} ></InputTextBox>
            </FormDiv>

        </FromSubmit>
    }
}





 

 
function MobilePanel(props) {
     
    return <div>
        {window.mobile != null && <div> شما با شماره {window.mobile} وارد شدید </div>}
        <span style={{ float: 'left' }}><SimpleButton title="خروج" Icon="LogOut" onClick={() => {
            window.mobile = "";
            localStorage.clear();
            $('#goToMain')[0].click();
           // setTimeout(() => { window.location = "/"; }, 1000);
        }}></SimpleButton>
        <a href="/" id="goToMain" />
        </span>
    </div>

}
 
 
   
export class ContactMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);
        this.readFromExcel = this.readFromExcel.bind(this);
    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Contact', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Contact', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }
    async readFromExcel()   {
        await window.$('#filex')[0].click();
  
        var d = document.getElementById('filex');
        d.value = null;
        d.onchange = null;
        d.onchange = () => {
            let f = new FormData();
            f.append('file', d.files[0]);
            let h = new Helper();
            let cmd = this;
            h.AjaxForUpload('Contact', 'Import', f, function (data) {
                if (data.status == 200) {
                    h.MessageBox(data.message, FixedMessage.Result);
                    cmd.componentDidMount();
                }
                else {
                    h.Error(data.message, FixedMessage.Result);

                }
            });

        };
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
               
                <center>
                    <Link to="/Admin/Contact/Add">
                      <SimpleButton title='مخاطب جدید' Icon='New'></SimpleButton>
                    </Link>
                    <SimpleButton title="درج از فایل اکسل" onClick={this.readFromExcel} Icon="Excel"></SimpleButton>
                    <a href="\temp\TempContact.xls" download="temp.xls" > دریافت نمونه فایل </a>
                </center>
                <input type="file" style={{ display: 'none' }} id="filex" accept=".xls"></input>
                <ProTable Records={this.state.Records} key={new Date().toString()} datasourcename='Contacts'>
                    <Column metaForDisplay={DataClass.Contact.id} />
                    <Column metaForDisplay={DataClass.Contact.title} />
              
                    <Column metaForDisplay={DataClass.Contact.mobile} />
              
                    <Column metaForDisplay={DataClass.Contact.descr} />

                    <Action caption="ویرایش" type="Link" Icon="Edit" pageName="/Contact/Edit" columnName="id" />


                    <Action caption="حذف" type="function" Icon="Delete" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}


export class Set_Contact extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = this.props.id;
        this.state = { Records: [], isLoaded: false };
        this.Submit = this.Submit.bind(this);
    }
    componentDidMount() {
        let helpCls = new Helper();
        let cmd = this;
        helpCls.Ajax('SendGroup', 'GetContact', { id: this.id },
            function (e) {
                console.log('Data Loaded!');
                cmd.setState({ isLoaded: true, Records: e });
            }, function (f) {
                console.log('Error');
            }
        );

    }
    Submit() {
        let hel = new Helper();
        let d = {
            id: this.id,
            contacts: hel.GetRecordWithCircita(window.Contacts, 'selected', true)
        };
        let cmd = this;
        hel.Ajax('SendGroup', 'SetContact', d,
            function (data) {
                hel.Alert(FixedMessage.NoProblem, FixedMessage.Result);
                hel.GoBack();
            }
            , function (err) {
                hel.Error(FixedMessage.ErrorRaise, FixedMessage.Result);
            }

        )


    }
    render() {
        if (this.state.isLoaded == false) {
            return <LoadingBar />;
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} staticTitle='تعیین مخاطبین' SubmitButtonOnTop={true} submitBev={this.Submit} >



                <ProTable Records={this.state.Records} datasourcename='Contacts'>
                    <Column type={ColumnType.DisplayValue} columnName='id' caption='شناسه ' />
                    <Column type={ColumnType.DisplayValue} columnName='title' caption='عنوان ' />
                    <Column type={ColumnType.InputCheck} columnName='selected' />
                </ProTable>
            </FromSubmit>

        }

    }

}


export class TemplateMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Template', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Template', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle='قالب ها'>
             
            
                 <FormDiv size='100%'>
                    <AddButton title='' entity='Template' />
                    <Link to='SetUser'>
                        <SimpleButton title='تعیین کاربران' Icon='User'></SimpleButton>

                    </Link>
                </FormDiv>
                <ProTable Records={this.state.Records} datasourcename='Templates'>
      
                    <Column metaForDisplay={DataClass.Template.id} />
                    <Column metaForDisplay={DataClass.Template.title} />
                    <Column metaForDisplay={DataClass.Template.context} />

                    <Action caption="ویرایش" type="Link" pageName="/Template/Edit" columnName="id" />


                    <Action caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}
export class MessageQuene extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { records: [] };
        this.readFromExcel = this.readFromExcel.bind(this);
    }
    componentDidMount() {
        let h = new Helper();
        let cmd = this;
        h.Ajax('Message', 'InProcess', {}, function (data) {
            window.messages = data;
            cmd.setState({ records: data });
        });
    }
    async readFromExcel() {
        await window.$('#filex')[0].click();

        var d = document.getElementById('filex');
        d.value = null;
        d.onchange = null;
        d.onchange = () => {
            let f = new FormData();
            f.append('file', d.files[0]);
            let h = new Helper();
            let cmd = this;
            h.AjaxForUpload('Message', 'Import', f, function (data) {
                if (data.status == 200) {
                    h.MessageBox(data.message, FixedMessage.Result);
                    cmd.componentDidMount();
                }
                else {
                    h.Error(data.message, FixedMessage.Result);

                }
            });

        };
    }
    cancel() {
        let hel = new Helper();
        let d = {
        
            messages: hel.GetRecordWithCircita(window.messages, 'selected', true)
        };
        let cmd = this;
        hel.Ajax('Message', 'Cancel', d,
            function (data) {
                hel.Alert(data.message, FixedMessage.Result);
                cmd.componentDidMount();
            }
            , function (err) {
                hel.Error(FixedMessage.ErrorRaise, FixedMessage.Result);
            }

        )


    }
    render() {
        return <FromBasic staticTitle='صف پیام ها'>
            <center>
                <Link to="NewMessage">
                  <SimpleButton Icon="New" title="پیام جدید"></SimpleButton>
                </Link>
                <Link to="SendGroup">
                    <SimpleButton Icon="Users" title="پیام به گروه انتشار"></SimpleButton>
                </Link>

                <SimpleButton Icon="Excel" onClick={this.readFromExcel} title="درج از اکسل"></SimpleButton>
                

                <SimpleButton Icon="Cancel" onClick={() => {
                    let h = new Helper();
                    let cmd = this;
                    h.ConfirmAction('آیا ارسال این پیام ها متوقف شوند', 'انصراف از ارسال', function () { cmd.cancel() });
                }} title="انصراف از ارسال"></SimpleButton>
             
            </center>
            <input type="file" style={{ display: 'none' }} id="filex" accept=".xls"></input>

            <ProTable datasourcename="messages" Records={this.state.records} key={new Date().toString()}>
                <Column metaForDisplay={DataClass.Message.mobile} />
                <Column metaForDisplay={DataClass.Message.message} />
                <Column metaForDisplay={DataClass.Message.createTime} />
                <Column metaForDisplay={DataClass.Message.status} />
                <Column columnName='selected' type={ColumnType.InputCheck} />
                <Column columnName='userName' caption='کاربر ایجاد کننده' type={ColumnType.DisplayValue} />
            </ProTable>
        </FromBasic>
    }

}




export class Inbox extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { records: [] }
        this.serach = this.serach.bind(this);
    }

    serach() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate()) {
            let d = h.GetPostData();
            h.Ajax('Message', 'Inbox', d, function (data) {
                cmd.setState({ records: data });
            });

        }

    }
    showDetail(r) {
        let h = new Helper();
        h.MessageBox("خطا :" + r.error);
    }
    render() {
        return <FromBasic >
            <InputTextBox size='33%' caption="موبایل" columnName="mobile" model="mobile"></InputTextBox>
            <InputTextBox size='33%' caption="از تاریخ" mustFill columnName="from" model="from" customHelper={CustomHelper.isDate}></InputTextBox>
            <InputTextBox size='33%' caption="تا تاریخ" mustFill columnName="to" model="to" customHelper={CustomHelper.isDate}></InputTextBox>
 
            <center>
                <SimpleButton title="نمایش" onClick={this.serach} Icon="View" ></SimpleButton>
            </center>
            <ProTable datasourcename="record" Records={this.state.records}>
                <Column metaForDisplay={DataClass.Message.mobile} />
                <Column metaForDisplay={DataClass.Message.message} />
                <Action caption="پاسخ " Icon="Edit" type="Link" pageName="/MessageQ/NewMessage" columnName="mobile" />

                       </ProTable>
        </FromBasic>;
    }
}

export class MessageSerach extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {records:[]}
        this.serach = this.serach.bind(this);
        this.resendSms = this.resendSms.bind(this);
    }

    serach() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate()) {
            let d = h.GetPostData();
            h.Ajax('Message', 'Serach', d, function (data) {
                cmd.setState({ records: data });
            });

        }

    }

    resendSms(r) {
        let cmd = this;
        let h = new Helper();
        
        h.ConfirmAction(FixedMessage.AreYouSure, 'پرسش', function () {

           
            h.Ajax('Message', 'ResendSms', { id: r.id }, function (data) {
                h.Alert(data.message);
                cmd.serach();
                });

            


        });


    }
     showDetail(r) {
        let h = new Helper();
        h.MessageBox("خطا :" + r.error);
    }
    render() {
        return <FromBasic >
            <InputTextBox size='50%' caption="موبایل" columnName="mobile" model="mobile"></InputTextBox>
            <InputTextBox size='50%' caption="از تاریخ" mustFill columnName="from" model="from" customHelper={CustomHelper.isDate}></InputTextBox>
            <InputTextBox size='50%' caption="تا تاریخ" mustFill columnName="to" model="to" customHelper={CustomHelper.isDate}></InputTextBox>

            <InputBox size='50%' meta={DataClass.Message.status}></InputBox>
            <center>
                <SimpleButton title="نمایش" onClick={this.serach} Icon="View" ></SimpleButton>
            </center>
            <ProTable datasourcename="record" Records={this.state.records}>
                <Column metaForDisplay={DataClass.Message.mobile} />
                <Column metaForDisplay={DataClass.Message.message} />
                <Column metaForDisplay={DataClass.Message.createTime} />
                <Column metaForDisplay={DataClass.Message.status} />
                <Column columnName='userName' caption='کاربر ایجاد کننده' type={ColumnType.DisplayValue} />
                <Action type="function" Icon="View" caption="نمایش جزئیات بیشتر" targetFun={this.showDetail } ></Action>
                <Action type="function" Icon="View" caption="ارسال مجدد" targetFun={this.resendSms} ></Action>

            </ProTable>
        </FromBasic>;
    }
}
export class AddMessage extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.mobile = props.mobile;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let cmd = this;
        let h = new Helper();
        h.AjaxSubmit('Message', 'SingleMessage',-1);

    }
    componentDidMount() {
        document.getElementById('txtmobile').value = this.mobile;
    }
    render() {
        return <FromSubmit submitBev={this.submit} staticTitle='پیام جدید'>
            <InputBox meta={DataClass.Message.mobile} />
            <InputBox meta={DataClass.Message.message} />
        </FromSubmit>
    }

}
export class AddMessageBatch extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.submit = this.submit.bind(this);
    }
    submit() {
        let cmd = this;
        let h = new Helper();
        h.AjaxSubmit('Message', 'BatchMessage', -1);

    }
    render() {
        let words = ['شناسه مخاطب', 'نام مخاطب', 'آدرس مخاطب', 'تاریخ ثبت', 'تاریخ امروز', 'شماره مخاطب' ]

        return <FromSubmit submitBev={this.submit} staticTitle='پیام جدید'>
            <DropDownBox entity="sendgroup" caption='گروه انتشار' columnName="SendGroupId" mustFill></DropDownBox> 
            <center>
                {words.map((v) => {
                    return <button className='btn btn-default' type="button" onClick={() => {
                        $('#txtcontext').val($('#txtcontext').val() + '[' + v + ']');


                    }}
                        style={{ float: 'right' }}>{v}</button>
                })}

            </center>
            <InputBox meta={DataClass.Template.context} size='100%' />



        </FromSubmit>;
    }

}



export class AddTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? '-1' : cmd.id);
        let o = h.GetPostData();
        h.Ajax('Template', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != '-1') {
            h.Ajax('Template', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        let words=['شناسه مخاطب','نام مخاطب','آدرس مخاطب','تاریخ ثبت','تاریخ امروز','شماره مخاطب','مقدار واکشی از بارکدخوان']
        return <FromSubmit submitBev={this.submit}>
         
            <InputBox meta={DataClass.Template.title} size='100%' />
            <center>
                {words.map((v) => {
                    return <button className='btn btn-default' type="button" onClick={() => {
                        $('#txtcontext').val($('#txtcontext').val() + '[' + v + ']');
                      
                     
                    }}
                  style={{ float: 'right' }}>{v}</button> })}

            </center>
            <InputBox meta={DataClass.Template.context} size='100%' />


        </FromSubmit>

    }

}
export class SetUserPanel extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Records: [] };

        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Template", "GetUsers", {}, function (datas) {
            window.users = datas;
            cmd.setState({ isLoaded: true, Records: datas });
      
        }, function () { });

    }
    submit() {
        let h = new Helper();
        let cmd = this;
        let changed = h.GetDataGrouped(window.users)[RowState.Changed];
        h.Ajax('Template', 'SetUsers', { changes: changed }, function
            (data) {
            if (data.status == '200') {
                h.MessageBox(data.message);
                h.GoBack();
            }
            else {
                h.Error(data.message);

            }
        });

    }
    render() {
        return <FromSubmit submitBev={this.submit} staticTitle='تعیین کاربران جهت قالب' >
            <ProTable datasourcename="users"  Records={this.state.Records} >
                <Column metaForDisplay={DataClass.User.UserId} />
                <Column metaForDisplay={DataClass.User.UserFullName} />
                <Column metaForInput={DataClass.User.TempId} titleColumnName='tempName' />
            </ProTable>
        </FromSubmit>

    }
}
export class SendGroupMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("SendGroup", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.SendGroups);
        h.Ajax('SendGroup', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='SendGroups' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.SendGroup.id} />
                    <Column metaForInput={DataClass.SendGroup.title} />
                    <Column metaForInput={DataClass.SendGroup.descr} />
                    <Action caption="تعیین مخاطبین" type="Link" Icon="User" pageName="/SetContact" columnName="id" />

                </ProTable>

            </FromSubmit>

        }

    }


}




export class UnitMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Unit", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.Units);
        h.Ajax('Unit', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit staticTitle="مدیریت واحد ها" SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='Units' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.Unit.id} />
                    <Column metaForInput={DataClass.Unit.title} />
                    <Column metaForInput={DataClass.Unit.bossName} />
                    <Column metaForInput={DataClass.Unit.eddName} />
                    <Column metaForInput={DataClass.Unit.eddPhone} />

                </ProTable>

            </FromSubmit>

        }

    }


}


export class AddContact extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.editMode = props.editMode;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('Contact', (this.editMode ==false ? 'Insert' : 'Update'), { Model: o, oldId: id }, function (data) {
       
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);
             
            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('Contact', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
            <InputBox meta={DataClass.Contact.id} size='50%' />
            <InputBox meta={DataClass.Contact.title} size='50%' />
            <InputBox meta={DataClass.Contact.address} size='50%' />
            <InputBox meta={DataClass.Contact.mobile} size='50%' />
            <InputBox meta={DataClass.Contact.otherPhones} size='100%' />
            <InputBox meta={DataClass.Contact.descr} size='100%' />


        </FromSubmit>

    }

}


export class HouseMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('House', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('House', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='House' /> <ProTable Records={this.state.Records} datasourcename='Houses'>
                    <Column metaForDisplay={DataClass.House.id} />
                    <Column metaForDisplay={DataClass.House.title} />
                    <Column metaForDisplay={DataClass.House.address} />
                    <Column metaForDisplay={DataClass.House.holder} />
                    <Column metaForDisplay={DataClass.House.holderPhone} />
                    <Column columnName="cityName" caption="شهر" type={ColumnType.DisplayValue} />
                    <Column columnName="unitName" caption="واحد کاری" type={ColumnType.DisplayValue} />
          

                    <Action caption="ویرایش" type="Link" Icon="Edit" pageName="/House/Edit" columnName="id" />
                    <Action caption="محل های اسکان" type="Link"  pageName="/House/SetProvide" columnName="id" />


                    <Action caption="حذف" type="function" Icon="Delete" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}

export class HousePartMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.id = this.props.id;
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("House", "PartList", {id:this.id}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        h.id = this.id;
        let data = h.GetDataGrouped(window.HouseParts);
        h.Ajax('House', 'PartSaveBatch', { id:this.id,Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='HouseParts' Records={this.state.Records} Insertable={true} Deleteable={true}>
                  
                    <Column metaForInput={DataClass.HousePart.title} />
                    <Column metaForInput={DataClass.HousePart.descr} />
                    <Column columnName="disabled" caption="غیرقابل سکونت" type={ColumnType.InputCheck}  />
                 

                </ProTable>

            </FromSubmit>

        }

    }


}

export class AddHouse extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('House', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('House', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
           
            <InputBox meta={DataClass.House.title} size='50%' />
            <InputBox meta={DataClass.House.holder} size='50%' />
           
            <InputBox meta={DataClass.House.holderPhone} size='33%' />
            <InputBox meta={DataClass.House.CityId} size='33%' />
             <InputBox meta={DataClass.House.UnitId} size='33%' />
            <InputBox meta={DataClass.House.address} size='100%' />


        </FromSubmit>

    }

}



export class CityMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("City", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.Citys);
        h.Ajax('City', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='Citys' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.City.id} />
                    <Column metaForInput={DataClass.City.title} />

                </ProTable>

            </FromSubmit>

        }

    }


}
export function HomePage(props) {

    const [pageState, setState] = useState({ data: null });

    const load = () => {
        let h = new Helper();
        h.Ajax('Home', 'ShareInfo', {}, (data) => {
            setState({ data: data });

        });


    };
    if (pageState.data == null) {
        load();
        return <LoadingBar />;
    }
    let h = new Helper();
    let sumery = h.GetDataGroupedByKey(pageState.data.summerys, 'header');
    const result = Object.entries(sumery).map(([key, value]) => {
        return { key: key, items: value };
    });


    if (sessionStorage.getItem("productId") != undefined) {
        setTimeout(() => { $("#mycart")[0].click(); }, 1000);
    }


    return <FromBasic>
        <center>
            <Link to="/Admin/MyCart" id="mycart" style={{display:'none'} } >سبد خرید</Link>
            <button type="button" onClick={() => {
                $('button[title="منو اصلی"]').click();

            }} className="btn btn-success " style={{ width:'95%' }}> منوی اصلی </button>
        </center>
        {pageState.data.per.map((x) => {
            if (x == 'Subciator') {
                return <NewGame />;
            }
            if (x == 'ClientHub') {
                return <ProductList />;
            }

        })}
        
        {result.map((v) => {
            return <FormDiv size="25%"><h4>{v.key}</h4>
                {v.items.map((v) => {
                    return <div class="bgConnerParent col-sm-12"><div className="bgConner  btn-success"  >
                        <div style={{ width: '80%', float: 'left' }}>

                            {v.title}
                            <br />
                            <Link to={"/Admin/" + v.link} >
                                جزئیات بیشتر
                            </Link>

                        </div>
                        <div className="counter" style={{ background: "linear-gradient(" + v.color + ",black 230%)" }}>
                            {h.addCommas(v.count)}
                        </div>


                    </div></div>

                })}
            <br/>
            </FormDiv>



        })

        }




    
        <br />
       <FromBasic>
        {pageState.data.charts.map((x) => {
            return <FormDiv size="33%">
                 
                <DynChart values={x.values} chartType={x.chartType} title={x.title}  ></DynChart>

            </FormDiv> 
        })}
        </FromBasic>
    </FromBasic>


}
function SmsReport() {


    const [pageState, setData] = useState({ records: [], isLoaded: false, grouped: [], filter: '', pageTemplate: [], templateId: -1 });


    const serach = () => {
        let h = new Helper();

        h.SaveState();
        h.Validate();
        if (h.isValidate() == false) {

            return;
        }
        let data = h.GetPostData();
        h.Ajax('SmsReport', 'Serach', data, (data) => {
            setData({ records: data, isLoaded: true, filter: '', grouped: pageState.grouped, pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };

    const ReSend = (record) => {
        let hlp = new Helper();

        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('SmsReport', 'Resend', { id: record.id }, function (data) {
             
                hlp.MessageBox(data.message, FixedMessage.Result);
             
            });
        });
    };

    const getCredit = () => {
        let hlp = new Helper();

         
            hlp.Ajax('SmsReport', 'GetCredit', {  }, function (data) {

                hlp.MessageBox(data.message, FixedMessage.Result);

            });
      
    }


 
 
    return <FromBasic>

      
           
               
                <InputTextBox caption="موبایل" columnName="mobile" model="mobile" size="33%"></InputTextBox>

        <InputTextBox caption="از تاریخ" columnName="start"   model="start" size="33%" customHelper={CustomHelper.isDate}></InputTextBox>
        <InputTextBox caption="تا تاریخ" columnName="end"   model="end" size="33%" customHelper={CustomHelper.isDate}></InputTextBox>
                <center>
                          </center>
         
       
        <center>
            <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>
            <SimpleButton onClick={getCredit } title="استعلام موجودی" ></SimpleButton>

    </center>

        {pageState.isLoaded &&
            <ProTable rowNumbering={true} datasourcename="records" key={Date().toString()} Records={pageState.records}>
                <Column metaForDisplay={DataClass.SmsReport.CreateTime} />
                <Column metaForDisplay={DataClass.SmsReport.Mobile} />
                <Column metaForDisplay={DataClass.SmsReport.Context} />
                <Column metaForDisplay={DataClass.SmsReport.ApplicationTitle} />
                <Column metaForDisplay={DataClass.SmsReport.Result} />
                     <Action caption="ارسال مجدد" type="function" targetFun={ReSend} />

            </ProTable>


        }

    </FromBasic>

}

export class UsageAccMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
    
        this.Refersh = this.Refersh.bind(this);
        this.Delete = this.Delete.bind(this);
    }
     Delete(record) {
         let h = new Helper();
         let cmd = this;
        h.ConfirmAction(FixedMessage.AreYouSure, "", () => {
            h.Ajax('AccountGaming', 'Delete', { id: record.id }, (data) => {
                h.Alert(data.message);
                cmd.Refersh();
                 

            })

        });

    }
    
    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('AccountGaming', 'ReadyForFactor', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    PriceShow(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.Ajax('Games', 'Get', { id: record.gameId }, (data) => {
            window.targetRecord = record;
           let recordsx = [...window.UsageAccs];
            window.setPrice = (e) => {
                let val = e.target.innerHTML;
                val = hlp.GetNumber(val.replace("تومان", "")) * 10;

                for (let i = 0; i < recordsx.length; i++) {
                    if (recordsx[i].id == window.targetRecord.id) {
                        
                        recordsx[i].accPrice = val;
                    }
                }
                let ob = { isLoaded: true, Records: recordsx }
                window.UsageAccs = ob.Records;
                cmd.setState(ob);
                window.currentTable.forceUpdate();
            }
            data.priceDescr = data.priceDescr.replace(/<button class='btn btn-primary'>/g, '<button onClick="window.setPrice(event)" class=\'btn btn-primary\'>')
            hlp.MessageBox(data.priceDescr, 'نمایش نرخ');

        });
    }
    createFactor(createOrder) {

       

        var selected = [];
        let h = new Helper();
        h.Validate();
        h.ConfirmAction("آیا مطمممن هستید?", "", () => {


            if (h.isValidate()) {
                var data = h.GetRecordWithCircita(window.UsageAccs, 'selected', true);
                h.Ajax('AccountGaming', 'SaveFactor', { createFactor: createOrder, records: data }
                    , (result) => {
                        if (result.status == 200) {
                            h.GoBack();
                        }
                        h.MessageBox(result.message, '');

                    }

                );
            }
        });
    }
    FactorSerach(record) {
        window.targetRecord = record;
        let factorSerach = window.open('/Admin/Sell/3');
        factorSerach.targetCallback = (id) => {
            record.orderId = id;
            window.currentTable.forceUpdate();
        };


    }
    makeConnectedFactor() {
        var selected = [];
        let h = new Helper();
        h.Validate();
        h.ConfirmAction("آیا مطمممن هستید?", "", () => {


            if (h.isValidate()) {
                var data = h.GetRecordWithCircita(window.UsageAccs, 'selected', true);
                h.Ajax('AccountGaming', 'MakeFactorOrderConnected', { records: data }
                    , (result) => {
                        if (result.status == 200) {
                            h.GoBack();
                        }
                        h.MessageBox(result.message, '');

                    }

                );
            }
        });
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <center>
                    <SimpleButton onClick={() => { this.createFactor(true); }} title="صدور فاکتور"></SimpleButton>
                    <SimpleButton onClick={() => { this.createFactor(false); }} title="عدم نیاز به  فاکتور"></SimpleButton>
                  
                </center>

                <AddButton title='' entity='UsageAcc' /> <ProTable  Records={this.state.Records} key={new Date().toString()} datasourcename='UsageAccs'>
                    <Column caption="انتخاب" columnName="selected" type={ColumnType.InputCheck} />
                    <Column metaForDisplay={DataClass.UsageAcc.usageType} />
        
                    <Column metaForDisplay={DataClass.UsageAcc.startDate} />
                    <Column metaForDisplay={DataClass.UsageAcc.endDate} />
                    <Column metaForDisplay={DataClass.UsageAcc.delvere} />
                    <Column metaForDisplay={DataClass.UsageAcc.descr} />
                  
         
                    <Column metaForDisplay={DataClass.UsageAcc.userName} />
                    <Column metaForDisplay={DataClass.UsageAcc.gameTitle} />
             
                    <Column metaForDisplay={DataClass.UsageAcc.email} />
                    <Column metaForInput={DataClass.UsageAcc.AccPrice} />
                    <Column metaForInput={DataClass.UsageAcc.DataPrice} />
                    <Action caption="ویرایش" Icon="Edit" type="Link" pageName="/UpdateUsageAcc" columnName="id" />
                    <Action caption="ویرایش شخص" Icon="Edit" type="Link" pageName="/User" columnName="userId" />
                    <Action caption="نمایش قیمت" type="function" Icon="Cat" targetFun={this.PriceShow} />
                    <Action caption="جست و جوی فاکتور" type="function" Icon="Cat" targetFun={this.FactorSerach} />
                    <Action caption="حذف " type="function" Icon="Cat" targetFun={this.Delete} />



                </ProTable>
            </FromBasic>
        }
    }



}
export function FixedPageConfig(props) {
    const [pageState, loadState] = useState({ pages: [] ,isLoaded:false});
    const load = () => {
        let h = new Helper();
        h.Ajax('FixedPage', 'List', {}, (data) => {

            loadState({ pages: data, isLoaded: true });
          
        })
    };
    const initEditor = () => {
        window.tinymce.EditorManager.remove();
        for (let i = 0; i < pageState.pages.length; i++) {
           
            window.tinymce.init({ selector: '#' + 'txt' + i, plugins: 'print preview fullpage searchreplace autolink directionality  visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime lists textcolor wordcount imagetools contextmenu colorpicker textpattern help', toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat', height: 400, resize: true });

        }

    };
    const submit = () => {
        var data = [];
        for (let i = 0; i < pageState.pages.length; i++) {
            data.push({ id: pageState.pages[i].id, value:window.tinymce.editors['txt'+i].contentDocument.body.innerHTML  })

         }
        //
        let h = new Helper();
        h.Ajax('FixedPage', 'Save', { pages: data }, (result) => {
            h.Alert(result.message);
            if (result.status == 200) {
                h.GoBack();
            }

        });

    };
    if (pageState.isLoaded == false) {
        load();
        return <LoadingBar />;
    }
    setTimeout(initEditor, 1000);
    return <FromSubmit submitBev={submit}>
      
        {pageState.pages.map((v,i) => {
            return <FormDiv size="100%">{v.id}:<br /><textarea width="100%"  id={"txt" + i} defaultValue={v.value} ></textarea></FormDiv>
        })}
        
    </FromSubmit> 


}

export function SmsPatternConfig(props) {
    const [pageState, loadState] = useState({ pages: [], isLoaded: false });
    const load = () => {
        let h = new Helper();
        h.Ajax('SmsPattern', 'List', {}, (data) => {

            loadState({ pages: data, isLoaded: true });

        })
    };
    const initEditor = () => {
       
    };
    const submit = () => {
        var data = [];
        for (let i = 0; i < pageState.pages.length; i++) {
            data.push({ name: pageState.pages[i].name, context:$('#txt' + i ).val() })

        }
        //
        let h = new Helper();
        h.Ajax('SmsPattern', 'Save', { pages: data }, (result) => {
            h.Alert(result.message);
            if (result.status == 200) {
                h.GoBack();
            }

        });

    };
    if (pageState.isLoaded == false) {
        load();
        return <LoadingBar />;
    }
    setTimeout(initEditor, 1000);
    return <FromSubmit submitBev={submit}>

        {pageState.pages.map((v, i) => {
            return <FormDiv size="100%">{v.name}:<br /><textarea width="100%" style={{ width: '100%' }} id={"txt" + i} defaultValue={v.context} ></textarea></FormDiv>
        })}

    </FromSubmit>


}




export class OrderItemForGameDevMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
  
        this.Refersh = this.Refersh.bind(this);

    }
 

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('AccountGaming', 'MustAccGive', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                  <ProTable Records={this.state.Records} datasourcename='OrderItemForGameDevs'>
                    <Column metaForDisplay={DataClass.OrderItemForGameDev.Id} />
                    <Column metaForDisplay={DataClass.OrderItemForGameDev.ProductId} />
                    <Column metaForDisplay={DataClass.OrderItemForGameDev.ProductName} />
                    <Column metaForDisplay={DataClass.OrderItemForGameDev.OrderDate} />
                    <Column metaForDisplay={DataClass.OrderItemForGameDev.CustomerName} />
                    <Column metaForDisplay={DataClass.OrderItemForGameDev.FactorNum} />

                    <Action caption="تحویل اکانت" type="Link" pageName="/SendAccToOrderItem" columnName="id" />


                   


                </ProTable>
            </FromBasic>
        }
    }



}
export function GiveAccNow(props) {

    const id = useParams().id;
    const [pageState, loadState] = useState({records:[],isLoaded:false });

    const load = () => {
        let h = new Helper();
        h.Ajax('AccountGaming', 'ReadyAccountForOrderItem', { id: id }
            , (data) => {
                loadState({ records: data, isLoaded: true });
            }

        )
    }
    const setAccId = (accId) => {
        let h = new Helper();
        h.ConfirmAction(FixedMessage.AreYouSure, "",
            () => {
                h.Ajax('AccountGaming', 'SetAccForOrderItem', {
                    orderItemId: id, accId: accId, customMessage: $('#txtcustomMessage').val()
                   

                }, (data) => {
                    h.Alert(data.message);
                    if (data.message == 200) {
                        h.GoBack();
                    }

                })
            });
        



    }


    if (pageState.isLoaded == false) {
        load();
        return <LoadingBar />
    }
    return <FromBasic>
        یک اکانت بازی انتخاب کنید <br />
        <InputTextBox caption="پیامک دلخواه" columnName="customMessage" customHelper={CustomHelper.LongText} model="customMessage" />
        {pageState.records.map((v) => <SimpleButton onClick={() => { setAccId(v.id) }} title={v.userName}></SimpleButton>)}



        <BackButton />
    </FromBasic>



}
function UseBackupCode(props) {
    const id = useParams().id;
    const [pageState, loadState] = useState({ codes: [], isLoaded: false });
    const load = () => {
        let h = new Helper();
        h.Ajax('AccountGaming', 'GetCodes', { id: id },
            (result) => {
                loadState({ codes: result, isLoaded: true });
            }
        )

    };
    const CodeNow = (code) => {
        let h = new Helper();
        h.ConfirmAction("کد استفاده شده : " + code, "", () => {
            h.Ajax('AccountGaming', 'UseCode', { id: id, code: code },
                (result) => {
                    h.Alert(result.message);
                    if (result.status == 200) {
                        h.GoBack();
                    }
                });
        });


    };
    const SendMsg=(code) => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        h.ConfirmAction("پیامک شود : " + code, "", () => {
            h.Ajax('AccountGaming', 'UseCodeAndSend', { id: id, code: code, mobile: $('#txtMobileNo').val() },
                (result) => {
                    h.Alert(result.message);
                    if (result.status == 200) {
                        h.GoBack();
                    }
                });
        });


    };
    if (pageState.isLoaded == false) {
        load();
        return <LoadingBar />;
    }
    return <FromBasic>
        <InputBox meta={DataClass.User.MobileNo} size="100%" />
        <BackButton />
        {pageState.codes.map((v) => {
            return <span style={{ display: 'block' }}>
                <SimpleButton style={{ width: '17%' }} onClick={() => { new Helper().shareText(v); }} title={"به اشتراک گذاری/کپی"}></SimpleButton>
                <SimpleButton style={{ width: '17%' }} onClick={() => { SendMsg(v)  }} title={"ارسال پیامک"}></SimpleButton>

                <SimpleButton style={{ width: '60%' }} onClick={() => { CodeNow(v); }} title={v}></SimpleButton> </span>
        })}
                </FromBasic>

  
}


export class GamingUserMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
          this.Refersh = this.Refersh.bind(this);

    }
    componentDidMount() {
        if (this.state.isLoaded == false) {
            this.Refersh(false);

        }


    }
   
    Refersh() {
        let com = this;
        new Helper().Ajax('AccountGaming', 'UserList', {   },
            function (Result) {
                com.setState({ isLoaded: true, Records: Result });
            }, function (err) { }
        );


    }
 

    render() {
        return <FromBasic staticTitle='اشتراک کاربران'> <center>لیست کاربران
            <br />
            <AddButton title="کاربر" entity="User" />
              <br />
            {this.state.isLoaded == false &&
                <LoadingBar />
            }
            {this.state.isLoaded == true &&
                <ProTable Records={this.state.Records} datasourcename='UserList'><Column type={ColumnType.DisplayValue} columnName='userId' ref={this.refs} caption='شناسه کاربری' ></Column>
                    <Column type={ColumnType.DisplayValue} columnName='userFullName' caption='نام کاربر' ref={this.refs} ></Column>
                    <Column metaForDisplay={DataClass.User.sex} width={200} />
                    <Column metaForDisplay={DataClass.User.actived} width={200} />
                  
                    <Action caption="ویرایش" Icon="Edit" type="Link" pageName="/GamingUser" columnName="userId" />
 
                </ProTable>} </center></FromBasic>;


    }


}






export class UpdateGamingUser extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.UserId = this.props.UserId;
        this.Submit = this.Submit.bind(this);
    }
    componentDidMount() {
        let helpCls = new Helper();
        helpCls.Ajax('AccountGaming', 'GetUser', { UserId: this.UserId },
            function (e) {
                helpCls.SetDataBack(e);
            }, function (f) { }
        );

    }

    Submit() {
        let helpCls = new Helper();

        let o = helpCls.GetPostData();
        o.UserId = this.UserId
        let data = { Model: o };
        helpCls.Validate();

        if (helpCls.isValidate() == false) {

            return false;
        }
        helpCls.Ajax('AccountGaming', 'UpdateGamingUser', o, function (s) {

            helpCls.Alert('با موفقیت ثبت گردید', 'اطلاعات');
            helpCls.GoBack();

        }, function (e) {
            console.log(JSON.stringify(e));
            helpCls.Error('خطا در ثبت', 'خطا');
        })
    }



    render() {
        return <FromSubmit staticTitle={'ویرایش کاربر' + ' ' + this.UserId} submitBev={this.Submit}>
            <InputBox meta={DataClass.User.planId} size='50%' />
            <InputBox meta={DataClass.User.endSub} size='50%' />
            <InputBox meta={DataClass.User.GameCount} size='50%' />
            <InputBox meta={DataClass.User.console} size='50%' />


   
        </FromSubmit >;
    }

}

export class AddUsageAcc extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('AccountGaming', ( 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('AccountGaming', 'GetUsageAcc', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
           
            <InputBox meta={DataClass.UsageAcc.startDate} size='50%' />
         
            <InputBox meta={DataClass.UsageAcc.delvere} size='50%' />
            <InputBox meta={DataClass.UsageAcc.descr} size='100%' />
         


        </FromSubmit>

    }

}
function EditUsageAcc(props) {
    let id = useParams().id;
    return <AddUsageAcc id={id } />

}

export class GameAccListReportMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
     
        this.Refersh = this.Refersh.bind(this);

    }

    

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('AccountGaming', 'GetAccountSummery', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <ProTable Records={this.state.Records} datasourcename='GameAccListReports'>
                    <Column metaForDisplay={DataClass.GameAccListReport.GameId} />
                    <Column metaForDisplay={DataClass.GameAccListReport.Title} />
                    <Column metaForDisplay={DataClass.GameAccListReport.GameType} />
                    <Column metaForDisplay={DataClass.GameAccListReport.Z2Ps4Count} />
                    <Column metaForDisplay={DataClass.GameAccListReport.Z2Ps5Count} />
                    <Column metaForDisplay={DataClass.GameAccListReport.Z3Count} />

                   


                </ProTable>
            </FromBasic>
        }
    }



}

export function SendSmsDirect() {
    const sendMsg = () => {
        var h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            h.Ajax("SmsReport", "SendDirect", h.GetPostData(),
                (data) => {
                    h.Alert(data.message);
                    if (data.status == '200') {
                        h.GoBack();
                    }
                });


        }


    };
    const allCustomers = () => {
        let h = new Helper();
      
   
       
            h.Ajax("SmsReport", "GetCustomerMobiles", h.GetPostData(),
                (data) => {
                    var mob = $('#txtmobiles').val();
                    for (var i = 0; i < data.length; i++) {
                        mob += data[i] + "\r\n";
                    }
                    $('#txtmobiles').val(mob);
                });


        

    };
    const allBuyerAProduct = () => {
        let h = new Helper();
        if ($('#txtProductId').val() == '') {
            h.errors.push("کد کالا وارد نشده است");
        }
        if (h.isValidate() == false) {
            return;
        }


        h.Ajax("SmsReport", "GetCustomerBuyAProduct", h.GetPostData(),
            (data) => {
                var mob = $('#txtmobiles').val();
                for (var i = 0; i < data.length; i++) {
                    mob += data[i] + "\r\n";
                }
                $('#txtmobiles').val(mob);
            });




    };
    const allBuyerACategory = () => {
        let h = new Helper();
        if ($('#txtcategroy').val() == '') {
            h.errors.push("کد دسته وارد نشده است");
        }
        if (h.isValidate() == false) {
            return;
        }


        h.Ajax("SmsReport", "GetCustomerBuyACategory", h.GetPostData(),
            (data) => {
                var mob = $('#txtmobiles').val();
                for (var i = 0; i < data.length; i++) {
                    mob += data[i] + "\r\n";
                }
                $('#txtmobiles').val(mob);
            });




    };


    return <FromSubmit submitBev={sendMsg}>
        <center>
            <SimpleButton onClick={allCustomers} title="همه مشتریان"></SimpleButton>

            <SimpleButton onClick={allBuyerAProduct } title="همه خریداران محصول"></SimpleButton>

            <SimpleButton onClick={allBuyerACategory} title="همه خریداران محصول دسته"></SimpleButton>
        </center>
        <DropDownBox caption="نام دسته" columnName="categroy" entity="ProdcutCategory" size="25%"  model="categroy" />
        <DropDownBox caption="نام کالا" entity="OrderItemProduct" size="25%" columnName="ProductId" />

      
        <InputTextBox caption="شماره های موبایل" model="mobiles" columnName="mobiles" mustFill="yes" customHelper={CustomHelper.LongText} >

        </InputTextBox>
        <InputTextBox caption="محتوا" columnName="context" model="context" mustFill="yes" customHelper={CustomHelper.LongText} >

        </InputTextBox>
    </FromSubmit>


}
export function ImportMessageExcel(prosp) {

   const  Import=() =>{
        let cx = document.getElementById('txtFile');
        let formData = new FormData();
     


        formData.append('file', cx.files[0], cx.value);

        let h = new Helper();
        h.AjaxForUpload('SmsReport', 'Import', formData, (data) => {
            h.Alert(data.message.replace(/\r\n/g, '<br/>'));
            h.download(data.message, 'result.txt');
            if (data.status == 200) {
                $('#txtFile').val(null);
                
            }
          
        });


    }

    return <FromBasic>
        <center>
        <input id="txtFile" type="file" />
                    <SimpleButton onClick={Import} title="ارسال فایل"></SimpleButton>
                    <a href="/MessageSample.xlsx" download="Temp.xlsx" >
                    دریافت فایل نمومه
            </a>
        </center>
    </FromBasic> 

}

export class ReadyTextMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("ReadyText", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.ReadyTexts);
        h.Ajax('ReadyText', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='ReadyTexts' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.ReadyText.Id} />
                    <Column metaForInput={DataClass.ReadyText.Title} />
                    <Column metaForInput={DataClass.ReadyText.Context} />

                </ProTable>

            </FromSubmit>

        }

    }


}
export function ImportXlsToSms(props) {
    const [levelState, loadLevelState] = useState({ level: 0 });
    const [excelData, setExcelDate] = useState({ columns: [],readyTexts:[], isLoaded: false });
    const Import = () => {
        let cx = document.getElementById('txtFile');
        let formData = new FormData();



        formData.append('file', cx.files[0], cx.value);

        let h = new Helper();
        h.AjaxForUpload('SmsReport', 'ImportTempXls', formData, (data) => {
          
            if (data.status == 200) {
                loadLevelState({ level: 1 });
                setExcelDate({ columns: data.columns, isLoaded: true, readyTexts: data.readyText });
            }
            else {
                h.Alert(data.message);
            }
        });


    }

    const submit = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            h.Ajax('SmsReport', 'SendBatchTemp', h.GetPostData(),
                (result) => {
                    h.Alert(result.message);
                    if (result.status == 200) {
                        h.GoBack();
                    }
                }

            );
        }

    }
    const insertText =(text)=> {
        const textarea = document.getElementById('txtcontext');
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        const before = textarea.value.substring(0, start);
        const after = textarea.value.substring(end);

        textarea.value = before + text + after;

        // برگرداندن کرسر به انتهای متن درج‌شده
        const newPos = start + text.length;
        textarea.selectionStart = textarea.selectionEnd = newPos;

        textarea.focus();
    }
    if (levelState.level == 0) {

        return <FromBasic>
            <center>
                <input id="txtFile" type="file" />
                <SimpleButton onClick={Import} title="ارسال فایل"></SimpleButton>
              
            </center>
        </FromBasic> 
    }
    if (levelState.level == 1) {

        return <FromSubmit submitBev={submit }>
         
            متن الگو
            <center>
                {excelData.readyTexts.map((v) => {
                    return <SimpleButton title={v.title} style={{ float:'right' }} onClick={() => { $('#txtcontext').val(v.context); }} />
                })}
            </center>

        <br/>
           درج مقدار 
            <center>
                {excelData.columns.map((v) => {
                    return <SimpleButton title={v.name} style={{ float: 'right' }} onClick={() => { insertText('[' +  v.name +']') }} />
                })}
            </center>

            <InputTextBox caption="متن الگو" columnName="context" customHelper={CustomHelper.LongText} size="100" mustFill="yes" model="context" ></InputTextBox>
        </FromSubmit>
    }

}


export { SmsReport, AdminPanel, EditUsageAcc, UseBackupCode, ClientPanel, LoginPage, ForgetPassword, loginMode, BasePage, UploadProfile, UserMgt, AddUser, UpdateUser, ChangePassForMySelf, RoleMgt, AddRole, Role_SetPermissions, Role_SetUser }